import { LogLevel as Ct, setLogExtension as Kn, setLogLevel as Gn, RoomEvent as y, ParticipantEvent as w, Track as $, TrackEvent as Jt, getBrowser as Qn, compareVersions as Jn, Room as Et } from "livekit-client";
import * as D from "react";
const Ue = Math.min, fe = Math.max, We = Math.round, Ie = Math.floor, te = (e) => ({
  x: e,
  y: e
}), Xn = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Zn = {
  start: "end",
  end: "start"
};
function Pt(e, t, n) {
  return fe(e, Ue(t, n));
}
function Ke(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function de(e) {
  return e.split("-")[0];
}
function Ge(e) {
  return e.split("-")[1];
}
function Xt(e) {
  return e === "x" ? "y" : "x";
}
function Zt(e) {
  return e === "y" ? "height" : "width";
}
const er = /* @__PURE__ */ new Set(["top", "bottom"]);
function ae(e) {
  return er.has(de(e)) ? "y" : "x";
}
function en(e) {
  return Xt(ae(e));
}
function tr(e, t, n) {
  n === void 0 && (n = !1);
  const r = Ge(e), i = en(e), o = Zt(i);
  let s = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[o] > t.floating[o] && (s = Be(s)), [s, Be(s)];
}
function nr(e) {
  const t = Be(e);
  return [ut(e), t, ut(t)];
}
function ut(e) {
  return e.replace(/start|end/g, (t) => Zn[t]);
}
const Ot = ["left", "right"], At = ["right", "left"], rr = ["top", "bottom"], ir = ["bottom", "top"];
function or(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? At : Ot : t ? Ot : At;
    case "left":
    case "right":
      return t ? rr : ir;
    default:
      return [];
  }
}
function sr(e, t, n, r) {
  const i = Ge(e);
  let o = or(de(e), n === "start", r);
  return i && (o = o.map((s) => s + "-" + i), t && (o = o.concat(o.map(ut)))), o;
}
function Be(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Xn[t]);
}
function ar(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function cr(e) {
  return typeof e != "number" ? ar(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function je(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: i
  } = e;
  return {
    width: r,
    height: i,
    top: n,
    left: t,
    right: t + r,
    bottom: n + i,
    x: t,
    y: n
  };
}
function _t(e, t, n) {
  let {
    reference: r,
    floating: i
  } = e;
  const o = ae(t), s = en(t), a = Zt(s), c = de(t), u = o === "y", l = r.x + r.width / 2 - i.width / 2, f = r.y + r.height / 2 - i.height / 2, v = r[a] / 2 - i[a] / 2;
  let d;
  switch (c) {
    case "top":
      d = {
        x: l,
        y: r.y - i.height
      };
      break;
    case "bottom":
      d = {
        x: l,
        y: r.y + r.height
      };
      break;
    case "right":
      d = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      d = {
        x: r.x - i.width,
        y: f
      };
      break;
    default:
      d = {
        x: r.x,
        y: r.y
      };
  }
  switch (Ge(t)) {
    case "start":
      d[s] -= v * (n && u ? -1 : 1);
      break;
    case "end":
      d[s] += v * (n && u ? -1 : 1);
      break;
  }
  return d;
}
async function ur(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: i,
    platform: o,
    rects: s,
    elements: a,
    strategy: c
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: l = "viewport",
    elementContext: f = "floating",
    altBoundary: v = !1,
    padding: d = 0
  } = Ke(t, e), m = cr(d), g = a[v ? f === "floating" ? "reference" : "floating" : f], h = je(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(g))) == null || n ? g : g.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(a.floating)),
    boundary: u,
    rootBoundary: l,
    strategy: c
  })), x = f === "floating" ? {
    x: r,
    y: i,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, T = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(a.floating)), E = await (o.isElement == null ? void 0 : o.isElement(T)) ? await (o.getScale == null ? void 0 : o.getScale(T)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = je(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: x,
    offsetParent: T,
    strategy: c
  }) : x);
  return {
    top: (h.top - S.top + m.top) / E.y,
    bottom: (S.bottom - h.bottom + m.bottom) / E.y,
    left: (h.left - S.left + m.left) / E.x,
    right: (S.right - h.right + m.right) / E.x
  };
}
const lr = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: o = [],
    platform: s
  } = n, a = o.filter(Boolean), c = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let u = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: l,
    y: f
  } = _t(u, r, c), v = r, d = {}, m = 0;
  for (let g = 0; g < a.length; g++) {
    var p;
    const {
      name: h,
      fn: x
    } = a[g], {
      x: T,
      y: E,
      data: S,
      reset: b
    } = await x({
      x: l,
      y: f,
      initialPlacement: r,
      placement: v,
      strategy: i,
      middlewareData: d,
      rects: u,
      platform: {
        ...s,
        detectOverflow: (p = s.detectOverflow) != null ? p : ur
      },
      elements: {
        reference: e,
        floating: t
      }
    });
    l = T ?? l, f = E ?? f, d = {
      ...d,
      [h]: {
        ...d[h],
        ...S
      }
    }, b && m <= 50 && (m++, typeof b == "object" && (b.placement && (v = b.placement), b.rects && (u = b.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : b.rects), {
      x: l,
      y: f
    } = _t(u, v, c)), g = -1);
  }
  return {
    x: l,
    y: f,
    placement: v,
    strategy: i,
    middlewareData: d
  };
}, fr = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        middlewareData: o,
        rects: s,
        initialPlacement: a,
        platform: c,
        elements: u
      } = t, {
        mainAxis: l = !0,
        crossAxis: f = !0,
        fallbackPlacements: v,
        fallbackStrategy: d = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: p = !0,
        ...g
      } = Ke(e, t);
      if ((n = o.arrow) != null && n.alignmentOffset)
        return {};
      const h = de(i), x = ae(a), T = de(a) === a, E = await (c.isRTL == null ? void 0 : c.isRTL(u.floating)), S = v || (T || !p ? [Be(a)] : nr(a)), b = m !== "none";
      !v && b && S.push(...sr(a, p, m, E));
      const P = [a, ...S], M = await c.detectOverflow(t, g), R = [];
      let W = ((r = o.flip) == null ? void 0 : r.overflows) || [];
      if (l && R.push(M[h]), f) {
        const k = tr(i, s, E);
        R.push(M[k[0]], M[k[1]]);
      }
      if (W = [...W, {
        placement: i,
        overflows: R
      }], !R.every((k) => k <= 0)) {
        var C, O;
        const k = (((C = o.flip) == null ? void 0 : C.index) || 0) + 1, F = P[k];
        if (F && (!(f === "alignment" ? x !== ae(F) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        W.every((N) => ae(N.placement) === x ? N.overflows[0] > 0 : !0)))
          return {
            data: {
              index: k,
              overflows: W
            },
            reset: {
              placement: F
            }
          };
        let G = (O = W.filter((J) => J.overflows[0] <= 0).sort((J, N) => J.overflows[1] - N.overflows[1])[0]) == null ? void 0 : O.placement;
        if (!G)
          switch (d) {
            case "bestFit": {
              var j;
              const J = (j = W.filter((N) => {
                if (b) {
                  const se = ae(N.placement);
                  return se === x || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  se === "y";
                }
                return !0;
              }).map((N) => [N.placement, N.overflows.filter((se) => se > 0).reduce((se, qn) => se + qn, 0)]).sort((N, se) => N[1] - se[1])[0]) == null ? void 0 : j[0];
              J && (G = J);
              break;
            }
            case "initialPlacement":
              G = a;
              break;
          }
        if (i !== G)
          return {
            reset: {
              placement: G
            }
          };
      }
      return {};
    }
  };
}, dr = /* @__PURE__ */ new Set(["left", "top"]);
async function pr(e, t) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = e, o = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), s = de(n), a = Ge(n), c = ae(n) === "y", u = dr.has(s) ? -1 : 1, l = o && c ? -1 : 1, f = Ke(t, e);
  let {
    mainAxis: v,
    crossAxis: d,
    alignmentAxis: m
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return a && typeof m == "number" && (d = a === "end" ? m * -1 : m), c ? {
    x: d * l,
    y: v * u
  } : {
    x: v * u,
    y: d * l
  };
}
const hr = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: i,
        y: o,
        placement: s,
        middlewareData: a
      } = t, c = await pr(t, e);
      return s === ((n = a.offset) == null ? void 0 : n.placement) && (r = a.arrow) != null && r.alignmentOffset ? {} : {
        x: i + c.x,
        y: o + c.y,
        data: {
          ...c,
          placement: s
        }
      };
    }
  };
}, vr = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: i,
        platform: o
      } = t, {
        mainAxis: s = !0,
        crossAxis: a = !1,
        limiter: c = {
          fn: (h) => {
            let {
              x,
              y: T
            } = h;
            return {
              x,
              y: T
            };
          }
        },
        ...u
      } = Ke(e, t), l = {
        x: n,
        y: r
      }, f = await o.detectOverflow(t, u), v = ae(de(i)), d = Xt(v);
      let m = l[d], p = l[v];
      if (s) {
        const h = d === "y" ? "top" : "left", x = d === "y" ? "bottom" : "right", T = m + f[h], E = m - f[x];
        m = Pt(T, m, E);
      }
      if (a) {
        const h = v === "y" ? "top" : "left", x = v === "y" ? "bottom" : "right", T = p + f[h], E = p - f[x];
        p = Pt(T, p, E);
      }
      const g = c.fn({
        ...t,
        [d]: m,
        [v]: p
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - r,
          enabled: {
            [d]: s,
            [v]: a
          }
        }
      };
    }
  };
};
function Qe() {
  return typeof window < "u";
}
function Se(e) {
  return tn(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function q(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function re(e) {
  var t;
  return (t = (tn(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function tn(e) {
  return Qe() ? e instanceof Node || e instanceof q(e).Node : !1;
}
function Z(e) {
  return Qe() ? e instanceof Element || e instanceof q(e).Element : !1;
}
function ne(e) {
  return Qe() ? e instanceof HTMLElement || e instanceof q(e).HTMLElement : !1;
}
function kt(e) {
  return !Qe() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof q(e).ShadowRoot;
}
const mr = /* @__PURE__ */ new Set(["inline", "contents"]);
function ke(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: i
  } = ee(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !mr.has(i);
}
const gr = /* @__PURE__ */ new Set(["table", "td", "th"]);
function br(e) {
  return gr.has(Se(e));
}
const yr = [":popover-open", ":modal"];
function Je(e) {
  return yr.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const wr = ["transform", "translate", "scale", "rotate", "perspective"], xr = ["transform", "translate", "scale", "rotate", "perspective", "filter"], Sr = ["paint", "layout", "strict", "content"];
function mt(e) {
  const t = gt(), n = Z(e) ? ee(e) : e;
  return wr.some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || xr.some((r) => (n.willChange || "").includes(r)) || Sr.some((r) => (n.contain || "").includes(r));
}
function Tr(e) {
  let t = ue(e);
  for (; ne(t) && !ye(t); ) {
    if (mt(t))
      return t;
    if (Je(t))
      return null;
    t = ue(t);
  }
  return null;
}
function gt() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const Cr = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function ye(e) {
  return Cr.has(Se(e));
}
function ee(e) {
  return q(e).getComputedStyle(e);
}
function Xe(e) {
  return Z(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function ue(e) {
  if (Se(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    kt(e) && e.host || // Fallback.
    re(e)
  );
  return kt(t) ? t.host : t;
}
function nn(e) {
  const t = ue(e);
  return ye(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : ne(t) && ke(t) ? t : nn(t);
}
function Pe(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = nn(e), o = i === ((r = e.ownerDocument) == null ? void 0 : r.body), s = q(i);
  if (o) {
    const a = lt(s);
    return t.concat(s, s.visualViewport || [], ke(i) ? i : [], a && n ? Pe(a) : []);
  }
  return t.concat(i, Pe(i, [], n));
}
function lt(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function rn(e) {
  const t = ee(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const i = ne(e), o = i ? e.offsetWidth : n, s = i ? e.offsetHeight : r, a = We(n) !== o || We(r) !== s;
  return a && (n = o, r = s), {
    width: n,
    height: r,
    $: a
  };
}
function bt(e) {
  return Z(e) ? e : e.contextElement;
}
function me(e) {
  const t = bt(e);
  if (!ne(t))
    return te(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: i,
    $: o
  } = rn(t);
  let s = (o ? We(n.width) : n.width) / r, a = (o ? We(n.height) : n.height) / i;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const Er = /* @__PURE__ */ te(0);
function on(e) {
  const t = q(e);
  return !gt() || !t.visualViewport ? Er : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Pr(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== q(e) ? !1 : t;
}
function pe(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), o = bt(e);
  let s = te(1);
  t && (r ? Z(r) && (s = me(r)) : s = me(e));
  const a = Pr(o, n, r) ? on(o) : te(0);
  let c = (i.left + a.x) / s.x, u = (i.top + a.y) / s.y, l = i.width / s.x, f = i.height / s.y;
  if (o) {
    const v = q(o), d = r && Z(r) ? q(r) : r;
    let m = v, p = lt(m);
    for (; p && r && d !== m; ) {
      const g = me(p), h = p.getBoundingClientRect(), x = ee(p), T = h.left + (p.clientLeft + parseFloat(x.paddingLeft)) * g.x, E = h.top + (p.clientTop + parseFloat(x.paddingTop)) * g.y;
      c *= g.x, u *= g.y, l *= g.x, f *= g.y, c += T, u += E, m = q(p), p = lt(m);
    }
  }
  return je({
    width: l,
    height: f,
    x: c,
    y: u
  });
}
function Ze(e, t) {
  const n = Xe(e).scrollLeft;
  return t ? t.left + n : pe(re(e)).left + n;
}
function sn(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - Ze(e, n), i = n.top + t.scrollTop;
  return {
    x: r,
    y: i
  };
}
function Or(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: i
  } = e;
  const o = i === "fixed", s = re(r), a = t ? Je(t.floating) : !1;
  if (r === s || a && o)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = te(1);
  const l = te(0), f = ne(r);
  if ((f || !f && !o) && ((Se(r) !== "body" || ke(s)) && (c = Xe(r)), ne(r))) {
    const d = pe(r);
    u = me(r), l.x = d.x + r.clientLeft, l.y = d.y + r.clientTop;
  }
  const v = s && !f && !o ? sn(s, c) : te(0);
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - c.scrollLeft * u.x + l.x + v.x,
    y: n.y * u.y - c.scrollTop * u.y + l.y + v.y
  };
}
function Ar(e) {
  return Array.from(e.getClientRects());
}
function _r(e) {
  const t = re(e), n = Xe(e), r = e.ownerDocument.body, i = fe(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), o = fe(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + Ze(e);
  const a = -n.scrollTop;
  return ee(r).direction === "rtl" && (s += fe(t.clientWidth, r.clientWidth) - i), {
    width: i,
    height: o,
    x: s,
    y: a
  };
}
const Lt = 25;
function kr(e, t) {
  const n = q(e), r = re(e), i = n.visualViewport;
  let o = r.clientWidth, s = r.clientHeight, a = 0, c = 0;
  if (i) {
    o = i.width, s = i.height;
    const l = gt();
    (!l || l && t === "fixed") && (a = i.offsetLeft, c = i.offsetTop);
  }
  const u = Ze(r);
  if (u <= 0) {
    const l = r.ownerDocument, f = l.body, v = getComputedStyle(f), d = l.compatMode === "CSS1Compat" && parseFloat(v.marginLeft) + parseFloat(v.marginRight) || 0, m = Math.abs(r.clientWidth - f.clientWidth - d);
    m <= Lt && (o -= m);
  } else u <= Lt && (o += u);
  return {
    width: o,
    height: s,
    x: a,
    y: c
  };
}
const Lr = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function Ir(e, t) {
  const n = pe(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, o = ne(e) ? me(e) : te(1), s = e.clientWidth * o.x, a = e.clientHeight * o.y, c = i * o.x, u = r * o.y;
  return {
    width: s,
    height: a,
    x: c,
    y: u
  };
}
function It(e, t, n) {
  let r;
  if (t === "viewport")
    r = kr(e, n);
  else if (t === "document")
    r = _r(re(e));
  else if (Z(t))
    r = Ir(t, n);
  else {
    const i = on(e);
    r = {
      x: t.x - i.x,
      y: t.y - i.y,
      width: t.width,
      height: t.height
    };
  }
  return je(r);
}
function an(e, t) {
  const n = ue(e);
  return n === t || !Z(n) || ye(n) ? !1 : ee(n).position === "fixed" || an(n, t);
}
function Mr(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Pe(e, [], !1).filter((a) => Z(a) && Se(a) !== "body"), i = null;
  const o = ee(e).position === "fixed";
  let s = o ? ue(e) : e;
  for (; Z(s) && !ye(s); ) {
    const a = ee(s), c = mt(s);
    !c && a.position === "fixed" && (i = null), (o ? !c && !i : !c && a.position === "static" && !!i && Lr.has(i.position) || ke(s) && !c && an(e, s)) ? r = r.filter((l) => l !== s) : i = a, s = ue(s);
  }
  return t.set(e, r), r;
}
function Rr(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = e;
  const s = [...n === "clippingAncestors" ? Je(t) ? [] : Mr(t, this._c) : [].concat(n), r], a = s[0], c = s.reduce((u, l) => {
    const f = It(t, l, i);
    return u.top = fe(f.top, u.top), u.right = Ue(f.right, u.right), u.bottom = Ue(f.bottom, u.bottom), u.left = fe(f.left, u.left), u;
  }, It(t, a, i));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function Dr(e) {
  const {
    width: t,
    height: n
  } = rn(e);
  return {
    width: t,
    height: n
  };
}
function Fr(e, t, n) {
  const r = ne(t), i = re(t), o = n === "fixed", s = pe(e, !0, o, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = te(0);
  function u() {
    c.x = Ze(i);
  }
  if (r || !r && !o)
    if ((Se(t) !== "body" || ke(i)) && (a = Xe(t)), r) {
      const d = pe(t, !0, o, t);
      c.x = d.x + t.clientLeft, c.y = d.y + t.clientTop;
    } else i && u();
  o && !r && i && u();
  const l = i && !r && !o ? sn(i, a) : te(0), f = s.left + a.scrollLeft - c.x - l.x, v = s.top + a.scrollTop - c.y - l.y;
  return {
    x: f,
    y: v,
    width: s.width,
    height: s.height
  };
}
function rt(e) {
  return ee(e).position === "static";
}
function Mt(e, t) {
  if (!ne(e) || ee(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return re(e) === n && (n = n.ownerDocument.body), n;
}
function cn(e, t) {
  const n = q(e);
  if (Je(e))
    return n;
  if (!ne(e)) {
    let i = ue(e);
    for (; i && !ye(i); ) {
      if (Z(i) && !rt(i))
        return i;
      i = ue(i);
    }
    return n;
  }
  let r = Mt(e, t);
  for (; r && br(r) && rt(r); )
    r = Mt(r, t);
  return r && ye(r) && rt(r) && !mt(r) ? n : r || Tr(e) || n;
}
const Nr = async function(e) {
  const t = this.getOffsetParent || cn, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: Fr(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function $r(e) {
  return ee(e).direction === "rtl";
}
const Ur = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Or,
  getDocumentElement: re,
  getClippingRect: Rr,
  getOffsetParent: cn,
  getElementRects: Nr,
  getClientRects: Ar,
  getDimensions: Dr,
  getScale: me,
  isElement: Z,
  isRTL: $r
};
function un(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Wr(e, t) {
  let n = null, r;
  const i = re(e);
  function o() {
    var a;
    clearTimeout(r), (a = n) == null || a.disconnect(), n = null;
  }
  function s(a, c) {
    a === void 0 && (a = !1), c === void 0 && (c = 1), o();
    const u = e.getBoundingClientRect(), {
      left: l,
      top: f,
      width: v,
      height: d
    } = u;
    if (a || t(), !v || !d)
      return;
    const m = Ie(f), p = Ie(i.clientWidth - (l + v)), g = Ie(i.clientHeight - (f + d)), h = Ie(l), T = {
      rootMargin: -m + "px " + -p + "px " + -g + "px " + -h + "px",
      threshold: fe(0, Ue(1, c)) || 1
    };
    let E = !0;
    function S(b) {
      const P = b[0].intersectionRatio;
      if (P !== c) {
        if (!E)
          return s();
        P ? s(!1, P) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      P === 1 && !un(u, e.getBoundingClientRect()) && s(), E = !1;
    }
    try {
      n = new IntersectionObserver(S, {
        ...T,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(S, T);
    }
    n.observe(e);
  }
  return s(!0), o;
}
function Br(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: o = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, u = bt(e), l = i || o ? [...u ? Pe(u) : [], ...Pe(t)] : [];
  l.forEach((h) => {
    i && h.addEventListener("scroll", n, {
      passive: !0
    }), o && h.addEventListener("resize", n);
  });
  const f = u && a ? Wr(u, n) : null;
  let v = -1, d = null;
  s && (d = new ResizeObserver((h) => {
    let [x] = h;
    x && x.target === u && d && (d.unobserve(t), cancelAnimationFrame(v), v = requestAnimationFrame(() => {
      var T;
      (T = d) == null || T.observe(t);
    })), n();
  }), u && !c && d.observe(u), d.observe(t));
  let m, p = c ? pe(e) : null;
  c && g();
  function g() {
    const h = pe(e);
    p && !un(p, h) && n(), p = h, m = requestAnimationFrame(g);
  }
  return n(), () => {
    var h;
    l.forEach((x) => {
      i && x.removeEventListener("scroll", n), o && x.removeEventListener("resize", n);
    }), f?.(), (h = d) == null || h.disconnect(), d = null, c && cancelAnimationFrame(m);
  };
}
const jr = hr, Vr = vr, Hr = fr, zr = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: Ur,
    ...n
  }, o = {
    ...i.platform,
    _c: r
  };
  return lr(e, t, {
    ...i,
    platform: o
  });
};
var os = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Yr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Fe = { exports: {} }, qr = Fe.exports, Rt;
function Kr() {
  return Rt || (Rt = 1, (function(e) {
    (function(t, n) {
      e.exports ? e.exports = n() : t.log = n();
    })(qr, function() {
      var t = function() {
      }, n = "undefined", r = typeof window !== n && typeof window.navigator !== n && /Trident\/|MSIE /.test(window.navigator.userAgent), i = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
      ], o = {}, s = null;
      function a(p, g) {
        var h = p[g];
        if (typeof h.bind == "function")
          return h.bind(p);
        try {
          return Function.prototype.bind.call(h, p);
        } catch {
          return function() {
            return Function.prototype.apply.apply(h, [p, arguments]);
          };
        }
      }
      function c() {
        console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
      }
      function u(p) {
        return p === "debug" && (p = "log"), typeof console === n ? !1 : p === "trace" && r ? c : console[p] !== void 0 ? a(console, p) : console.log !== void 0 ? a(console, "log") : t;
      }
      function l() {
        for (var p = this.getLevel(), g = 0; g < i.length; g++) {
          var h = i[g];
          this[h] = g < p ? t : this.methodFactory(h, p, this.name);
        }
        if (this.log = this.debug, typeof console === n && p < this.levels.SILENT)
          return "No console available for logging";
      }
      function f(p) {
        return function() {
          typeof console !== n && (l.call(this), this[p].apply(this, arguments));
        };
      }
      function v(p, g, h) {
        return u(p) || f.apply(this, arguments);
      }
      function d(p, g) {
        var h = this, x, T, E, S = "loglevel";
        typeof p == "string" ? S += ":" + p : typeof p == "symbol" && (S = void 0);
        function b(C) {
          var O = (i[C] || "silent").toUpperCase();
          if (!(typeof window === n || !S)) {
            try {
              window.localStorage[S] = O;
              return;
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(S) + "=" + O + ";";
            } catch {
            }
          }
        }
        function P() {
          var C;
          if (!(typeof window === n || !S)) {
            try {
              C = window.localStorage[S];
            } catch {
            }
            if (typeof C === n)
              try {
                var O = window.document.cookie, j = encodeURIComponent(S), k = O.indexOf(j + "=");
                k !== -1 && (C = /^([^;]+)/.exec(
                  O.slice(k + j.length + 1)
                )[1]);
              } catch {
              }
            return h.levels[C] === void 0 && (C = void 0), C;
          }
        }
        function M() {
          if (!(typeof window === n || !S)) {
            try {
              window.localStorage.removeItem(S);
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(S) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
            } catch {
            }
          }
        }
        function R(C) {
          var O = C;
          if (typeof O == "string" && h.levels[O.toUpperCase()] !== void 0 && (O = h.levels[O.toUpperCase()]), typeof O == "number" && O >= 0 && O <= h.levels.SILENT)
            return O;
          throw new TypeError("log.setLevel() called with invalid level: " + C);
        }
        h.name = p, h.levels = {
          TRACE: 0,
          DEBUG: 1,
          INFO: 2,
          WARN: 3,
          ERROR: 4,
          SILENT: 5
        }, h.methodFactory = g || v, h.getLevel = function() {
          return E ?? T ?? x;
        }, h.setLevel = function(C, O) {
          return E = R(C), O !== !1 && b(E), l.call(h);
        }, h.setDefaultLevel = function(C) {
          T = R(C), P() || h.setLevel(C, !1);
        }, h.resetLevel = function() {
          E = null, M(), l.call(h);
        }, h.enableAll = function(C) {
          h.setLevel(h.levels.TRACE, C);
        }, h.disableAll = function(C) {
          h.setLevel(h.levels.SILENT, C);
        }, h.rebuild = function() {
          if (s !== h && (x = R(s.getLevel())), l.call(h), s === h)
            for (var C in o)
              o[C].rebuild();
        }, x = R(
          s ? s.getLevel() : "WARN"
        );
        var W = P();
        W != null && (E = R(W)), l.call(h);
      }
      s = new d(), s.getLogger = function(g) {
        if (typeof g != "symbol" && typeof g != "string" || g === "")
          throw new TypeError("You must supply a name when creating a logger.");
        var h = o[g];
        return h || (h = o[g] = new d(
          g,
          s.methodFactory
        )), h;
      };
      var m = typeof window !== n ? window.log : void 0;
      return s.noConflict = function() {
        return typeof window !== n && window.log === s && (window.log = m), s;
      }, s.getLoggers = function() {
        return o;
      }, s.default = s, s;
    });
  })(Fe)), Fe.exports;
}
var Gr = Kr();
const Qr = /* @__PURE__ */ Yr(Gr);
var ft = function(e, t) {
  return ft = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
  }, ft(e, t);
};
function oe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  ft(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
function Jr(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(s) {
      s(o);
    });
  }
  return new (n || (n = Promise))(function(o, s) {
    function a(l) {
      try {
        u(r.next(l));
      } catch (f) {
        s(f);
      }
    }
    function c(l) {
      try {
        u(r.throw(l));
      } catch (f) {
        s(f);
      }
    }
    function u(l) {
      l.done ? o(l.value) : i(l.value).then(a, c);
    }
    u((r = r.apply(e, t || [])).next());
  });
}
function ln(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, s = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return s.next = a(0), s.throw = a(1), s.return = a(2), typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function a(u) {
    return function(l) {
      return c([u, l]);
    };
  }
  function c(u) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; s && (s = 0, u[0] && (n = 0)), n; ) try {
      if (r = 1, i && (o = u[0] & 2 ? i.return : u[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, u[1])).done) return o;
      switch (i = 0, o && (u = [u[0] & 2, o.value]), u[0]) {
        case 0:
        case 1:
          o = u;
          break;
        case 4:
          return n.label++, { value: u[1], done: !1 };
        case 5:
          n.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            n = 0;
            continue;
          }
          if (u[0] === 3 && (!o || u[1] > o[0] && u[1] < o[3])) {
            n.label = u[1];
            break;
          }
          if (u[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = u;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(u);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      u = t.call(e, n);
    } catch (l) {
      u = [6, l], i = 0;
    } finally {
      r = o = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function we(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function he(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (s) throw s.error;
    }
  }
  return o;
}
function xe(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
function ge(e) {
  return this instanceof ge ? (this.v = e, this) : new ge(e);
}
function Xr(e, t, n) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = n.apply(e, t || []), i, o = [];
  return i = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), a("next"), a("throw"), a("return", s), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function s(d) {
    return function(m) {
      return Promise.resolve(m).then(d, f);
    };
  }
  function a(d, m) {
    r[d] && (i[d] = function(p) {
      return new Promise(function(g, h) {
        o.push([d, p, g, h]) > 1 || c(d, p);
      });
    }, m && (i[d] = m(i[d])));
  }
  function c(d, m) {
    try {
      u(r[d](m));
    } catch (p) {
      v(o[0][3], p);
    }
  }
  function u(d) {
    d.value instanceof ge ? Promise.resolve(d.value.v).then(l, f) : v(o[0][2], d);
  }
  function l(d) {
    c("next", d);
  }
  function f(d) {
    c("throw", d);
  }
  function v(d, m) {
    d(m), o.shift(), o.length && c(o[0][0], o[0][1]);
  }
}
function Zr(e) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = e[Symbol.asyncIterator], n;
  return t ? t.call(e) : (e = typeof we == "function" ? we(e) : e[Symbol.iterator](), n = {}, r("next"), r("throw"), r("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function r(o) {
    n[o] = e[o] && function(s) {
      return new Promise(function(a, c) {
        s = e[o](s), i(a, c, s.done, s.value);
      });
    };
  }
  function i(o, s, a, c) {
    Promise.resolve(c).then(function(u) {
      o({ value: u, done: a });
    }, s);
  }
}
function A(e) {
  return typeof e == "function";
}
function yt(e) {
  var t = function(r) {
    Error.call(r), r.stack = new Error().stack;
  }, n = e(t);
  return n.prototype = Object.create(Error.prototype), n.prototype.constructor = n, n;
}
var it = yt(function(e) {
  return function(n) {
    e(this), this.message = n ? n.length + ` errors occurred during unsubscription:
` + n.map(function(r, i) {
      return i + 1 + ") " + r.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = n;
  };
});
function Ve(e, t) {
  if (e) {
    var n = e.indexOf(t);
    0 <= n && e.splice(n, 1);
  }
}
var Le = (function() {
  function e(t) {
    this.initialTeardown = t, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return e.prototype.unsubscribe = function() {
    var t, n, r, i, o;
    if (!this.closed) {
      this.closed = !0;
      var s = this._parentage;
      if (s)
        if (this._parentage = null, Array.isArray(s))
          try {
            for (var a = we(s), c = a.next(); !c.done; c = a.next()) {
              var u = c.value;
              u.remove(this);
            }
          } catch (p) {
            t = { error: p };
          } finally {
            try {
              c && !c.done && (n = a.return) && n.call(a);
            } finally {
              if (t) throw t.error;
            }
          }
        else
          s.remove(this);
      var l = this.initialTeardown;
      if (A(l))
        try {
          l();
        } catch (p) {
          o = p instanceof it ? p.errors : [p];
        }
      var f = this._finalizers;
      if (f) {
        this._finalizers = null;
        try {
          for (var v = we(f), d = v.next(); !d.done; d = v.next()) {
            var m = d.value;
            try {
              Dt(m);
            } catch (p) {
              o = o ?? [], p instanceof it ? o = xe(xe([], he(o)), he(p.errors)) : o.push(p);
            }
          }
        } catch (p) {
          r = { error: p };
        } finally {
          try {
            d && !d.done && (i = v.return) && i.call(v);
          } finally {
            if (r) throw r.error;
          }
        }
      }
      if (o)
        throw new it(o);
    }
  }, e.prototype.add = function(t) {
    var n;
    if (t && t !== this)
      if (this.closed)
        Dt(t);
      else {
        if (t instanceof e) {
          if (t.closed || t._hasParent(this))
            return;
          t._addParent(this);
        }
        (this._finalizers = (n = this._finalizers) !== null && n !== void 0 ? n : []).push(t);
      }
  }, e.prototype._hasParent = function(t) {
    var n = this._parentage;
    return n === t || Array.isArray(n) && n.includes(t);
  }, e.prototype._addParent = function(t) {
    var n = this._parentage;
    this._parentage = Array.isArray(n) ? (n.push(t), n) : n ? [n, t] : t;
  }, e.prototype._removeParent = function(t) {
    var n = this._parentage;
    n === t ? this._parentage = null : Array.isArray(n) && Ve(n, t);
  }, e.prototype.remove = function(t) {
    var n = this._finalizers;
    n && Ve(n, t), t instanceof e && t._removeParent(this);
  }, e.EMPTY = (function() {
    var t = new e();
    return t.closed = !0, t;
  })(), e;
})(), fn = Le.EMPTY;
function dn(e) {
  return e instanceof Le || e && "closed" in e && A(e.remove) && A(e.add) && A(e.unsubscribe);
}
function Dt(e) {
  A(e) ? e() : e.unsubscribe();
}
var ei = {
  Promise: void 0
}, ti = {
  setTimeout: function(e, t) {
    for (var n = [], r = 2; r < arguments.length; r++)
      n[r - 2] = arguments[r];
    return setTimeout.apply(void 0, xe([e, t], he(n)));
  },
  clearTimeout: function(e) {
    return clearTimeout(e);
  },
  delegate: void 0
};
function pn(e) {
  ti.setTimeout(function() {
    throw e;
  });
}
function He() {
}
function Ne(e) {
  e();
}
var wt = (function(e) {
  oe(t, e);
  function t(n) {
    var r = e.call(this) || this;
    return r.isStopped = !1, n ? (r.destination = n, dn(n) && n.add(r)) : r.destination = ii, r;
  }
  return t.create = function(n, r, i) {
    return new Oe(n, r, i);
  }, t.prototype.next = function(n) {
    this.isStopped || this._next(n);
  }, t.prototype.error = function(n) {
    this.isStopped || (this.isStopped = !0, this._error(n));
  }, t.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, t.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this), this.destination = null);
  }, t.prototype._next = function(n) {
    this.destination.next(n);
  }, t.prototype._error = function(n) {
    try {
      this.destination.error(n);
    } finally {
      this.unsubscribe();
    }
  }, t.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, t;
})(Le), ni = (function() {
  function e(t) {
    this.partialObserver = t;
  }
  return e.prototype.next = function(t) {
    var n = this.partialObserver;
    if (n.next)
      try {
        n.next(t);
      } catch (r) {
        Me(r);
      }
  }, e.prototype.error = function(t) {
    var n = this.partialObserver;
    if (n.error)
      try {
        n.error(t);
      } catch (r) {
        Me(r);
      }
    else
      Me(t);
  }, e.prototype.complete = function() {
    var t = this.partialObserver;
    if (t.complete)
      try {
        t.complete();
      } catch (n) {
        Me(n);
      }
  }, e;
})(), Oe = (function(e) {
  oe(t, e);
  function t(n, r, i) {
    var o = e.call(this) || this, s;
    return A(n) || !n ? s = {
      next: n ?? void 0,
      error: r ?? void 0,
      complete: i ?? void 0
    } : s = n, o.destination = new ni(s), o;
  }
  return t;
})(wt);
function Me(e) {
  pn(e);
}
function ri(e) {
  throw e;
}
var ii = {
  closed: !0,
  next: He,
  error: ri,
  complete: He
}, xt = (function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
})();
function et(e) {
  return e;
}
function oi(e) {
  return e.length === 0 ? et : e.length === 1 ? e[0] : function(n) {
    return e.reduce(function(r, i) {
      return i(r);
    }, n);
  };
}
var L = (function() {
  function e(t) {
    t && (this._subscribe = t);
  }
  return e.prototype.lift = function(t) {
    var n = new e();
    return n.source = this, n.operator = t, n;
  }, e.prototype.subscribe = function(t, n, r) {
    var i = this, o = ai(t) ? t : new Oe(t, n, r);
    return Ne(function() {
      var s = i, a = s.operator, c = s.source;
      o.add(a ? a.call(o, c) : c ? i._subscribe(o) : i._trySubscribe(o));
    }), o;
  }, e.prototype._trySubscribe = function(t) {
    try {
      return this._subscribe(t);
    } catch (n) {
      t.error(n);
    }
  }, e.prototype.forEach = function(t, n) {
    var r = this;
    return n = Ft(n), new n(function(i, o) {
      var s = new Oe({
        next: function(a) {
          try {
            t(a);
          } catch (c) {
            o(c), s.unsubscribe();
          }
        },
        error: o,
        complete: i
      });
      r.subscribe(s);
    });
  }, e.prototype._subscribe = function(t) {
    var n;
    return (n = this.source) === null || n === void 0 ? void 0 : n.subscribe(t);
  }, e.prototype[xt] = function() {
    return this;
  }, e.prototype.pipe = function() {
    for (var t = [], n = 0; n < arguments.length; n++)
      t[n] = arguments[n];
    return oi(t)(this);
  }, e.prototype.toPromise = function(t) {
    var n = this;
    return t = Ft(t), new t(function(r, i) {
      var o;
      n.subscribe(function(s) {
        return o = s;
      }, function(s) {
        return i(s);
      }, function() {
        return r(o);
      });
    });
  }, e.create = function(t) {
    return new e(t);
  }, e;
})();
function Ft(e) {
  var t;
  return (t = e ?? ei.Promise) !== null && t !== void 0 ? t : Promise;
}
function si(e) {
  return e && A(e.next) && A(e.error) && A(e.complete);
}
function ai(e) {
  return e && e instanceof wt || si(e) && dn(e);
}
function ci(e) {
  return A(e?.lift);
}
function B(e) {
  return function(t) {
    if (ci(t))
      return t.lift(function(n) {
        try {
          return e(n, this);
        } catch (r) {
          this.error(r);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function z(e, t, n, r, i) {
  return new ui(e, t, n, r, i);
}
var ui = (function(e) {
  oe(t, e);
  function t(n, r, i, o, s, a) {
    var c = e.call(this, n) || this;
    return c.onFinalize = s, c.shouldUnsubscribe = a, c._next = r ? function(u) {
      try {
        r(u);
      } catch (l) {
        n.error(l);
      }
    } : e.prototype._next, c._error = o ? function(u) {
      try {
        o(u);
      } catch (l) {
        n.error(l);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._error, c._complete = i ? function() {
      try {
        i();
      } catch (u) {
        n.error(u);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._complete, c;
  }
  return t.prototype.unsubscribe = function() {
    var n;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var r = this.closed;
      e.prototype.unsubscribe.call(this), !r && ((n = this.onFinalize) === null || n === void 0 || n.call(this));
    }
  }, t;
})(wt), li = yt(function(e) {
  return function() {
    e(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), ie = (function(e) {
  oe(t, e);
  function t() {
    var n = e.call(this) || this;
    return n.closed = !1, n.currentObservers = null, n.observers = [], n.isStopped = !1, n.hasError = !1, n.thrownError = null, n;
  }
  return t.prototype.lift = function(n) {
    var r = new Nt(this, this);
    return r.operator = n, r;
  }, t.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new li();
  }, t.prototype.next = function(n) {
    var r = this;
    Ne(function() {
      var i, o;
      if (r._throwIfClosed(), !r.isStopped) {
        r.currentObservers || (r.currentObservers = Array.from(r.observers));
        try {
          for (var s = we(r.currentObservers), a = s.next(); !a.done; a = s.next()) {
            var c = a.value;
            c.next(n);
          }
        } catch (u) {
          i = { error: u };
        } finally {
          try {
            a && !a.done && (o = s.return) && o.call(s);
          } finally {
            if (i) throw i.error;
          }
        }
      }
    });
  }, t.prototype.error = function(n) {
    var r = this;
    Ne(function() {
      if (r._throwIfClosed(), !r.isStopped) {
        r.hasError = r.isStopped = !0, r.thrownError = n;
        for (var i = r.observers; i.length; )
          i.shift().error(n);
      }
    });
  }, t.prototype.complete = function() {
    var n = this;
    Ne(function() {
      if (n._throwIfClosed(), !n.isStopped) {
        n.isStopped = !0;
        for (var r = n.observers; r.length; )
          r.shift().complete();
      }
    });
  }, t.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(t.prototype, "observed", {
    get: function() {
      var n;
      return ((n = this.observers) === null || n === void 0 ? void 0 : n.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype._trySubscribe = function(n) {
    return this._throwIfClosed(), e.prototype._trySubscribe.call(this, n);
  }, t.prototype._subscribe = function(n) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(n), this._innerSubscribe(n);
  }, t.prototype._innerSubscribe = function(n) {
    var r = this, i = this, o = i.hasError, s = i.isStopped, a = i.observers;
    return o || s ? fn : (this.currentObservers = null, a.push(n), new Le(function() {
      r.currentObservers = null, Ve(a, n);
    }));
  }, t.prototype._checkFinalizedStatuses = function(n) {
    var r = this, i = r.hasError, o = r.thrownError, s = r.isStopped;
    i ? n.error(o) : s && n.complete();
  }, t.prototype.asObservable = function() {
    var n = new L();
    return n.source = this, n;
  }, t.create = function(n, r) {
    return new Nt(n, r);
  }, t;
})(L), Nt = (function(e) {
  oe(t, e);
  function t(n, r) {
    var i = e.call(this) || this;
    return i.destination = n, i.source = r, i;
  }
  return t.prototype.next = function(n) {
    var r, i;
    (i = (r = this.destination) === null || r === void 0 ? void 0 : r.next) === null || i === void 0 || i.call(r, n);
  }, t.prototype.error = function(n) {
    var r, i;
    (i = (r = this.destination) === null || r === void 0 ? void 0 : r.error) === null || i === void 0 || i.call(r, n);
  }, t.prototype.complete = function() {
    var n, r;
    (r = (n = this.destination) === null || n === void 0 ? void 0 : n.complete) === null || r === void 0 || r.call(n);
  }, t.prototype._subscribe = function(n) {
    var r, i;
    return (i = (r = this.source) === null || r === void 0 ? void 0 : r.subscribe(n)) !== null && i !== void 0 ? i : fn;
  }, t;
})(ie), hn = (function(e) {
  oe(t, e);
  function t(n) {
    var r = e.call(this) || this;
    return r._value = n, r;
  }
  return Object.defineProperty(t.prototype, "value", {
    get: function() {
      return this.getValue();
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype._subscribe = function(n) {
    var r = e.prototype._subscribe.call(this, n);
    return !r.closed && n.next(this._value), r;
  }, t.prototype.getValue = function() {
    var n = this, r = n.hasError, i = n.thrownError, o = n._value;
    if (r)
      throw i;
    return this._throwIfClosed(), o;
  }, t.prototype.next = function(n) {
    e.prototype.next.call(this, this._value = n);
  }, t;
})(ie), fi = {
  now: function() {
    return Date.now();
  }
}, di = (function(e) {
  oe(t, e);
  function t(n, r) {
    return e.call(this) || this;
  }
  return t.prototype.schedule = function(n, r) {
    return this;
  }, t;
})(Le), $t = {
  setInterval: function(e, t) {
    for (var n = [], r = 2; r < arguments.length; r++)
      n[r - 2] = arguments[r];
    return setInterval.apply(void 0, xe([e, t], he(n)));
  },
  clearInterval: function(e) {
    return clearInterval(e);
  },
  delegate: void 0
}, pi = (function(e) {
  oe(t, e);
  function t(n, r) {
    var i = e.call(this, n, r) || this;
    return i.scheduler = n, i.work = r, i.pending = !1, i;
  }
  return t.prototype.schedule = function(n, r) {
    var i;
    if (r === void 0 && (r = 0), this.closed)
      return this;
    this.state = n;
    var o = this.id, s = this.scheduler;
    return o != null && (this.id = this.recycleAsyncId(s, o, r)), this.pending = !0, this.delay = r, this.id = (i = this.id) !== null && i !== void 0 ? i : this.requestAsyncId(s, this.id, r), this;
  }, t.prototype.requestAsyncId = function(n, r, i) {
    return i === void 0 && (i = 0), $t.setInterval(n.flush.bind(n, this), i);
  }, t.prototype.recycleAsyncId = function(n, r, i) {
    if (i === void 0 && (i = 0), i != null && this.delay === i && this.pending === !1)
      return r;
    r != null && $t.clearInterval(r);
  }, t.prototype.execute = function(n, r) {
    if (this.closed)
      return new Error("executing a cancelled action");
    this.pending = !1;
    var i = this._execute(n, r);
    if (i)
      return i;
    this.pending === !1 && this.id != null && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
  }, t.prototype._execute = function(n, r) {
    var i = !1, o;
    try {
      this.work(n);
    } catch (s) {
      i = !0, o = s || new Error("Scheduled action threw falsy error");
    }
    if (i)
      return this.unsubscribe(), o;
  }, t.prototype.unsubscribe = function() {
    if (!this.closed) {
      var n = this, r = n.id, i = n.scheduler, o = i.actions;
      this.work = this.state = this.scheduler = null, this.pending = !1, Ve(o, this), r != null && (this.id = this.recycleAsyncId(i, r, null)), this.delay = null, e.prototype.unsubscribe.call(this);
    }
  }, t;
})(di), Ut = (function() {
  function e(t, n) {
    n === void 0 && (n = e.now), this.schedulerActionCtor = t, this.now = n;
  }
  return e.prototype.schedule = function(t, n, r) {
    return n === void 0 && (n = 0), new this.schedulerActionCtor(this, t).schedule(r, n);
  }, e.now = fi.now, e;
})(), hi = (function(e) {
  oe(t, e);
  function t(n, r) {
    r === void 0 && (r = Ut.now);
    var i = e.call(this, n, r) || this;
    return i.actions = [], i._active = !1, i;
  }
  return t.prototype.flush = function(n) {
    var r = this.actions;
    if (this._active) {
      r.push(n);
      return;
    }
    var i;
    this._active = !0;
    do
      if (i = n.execute(n.state, n.delay))
        break;
    while (n = r.shift());
    if (this._active = !1, i) {
      for (; n = r.shift(); )
        n.unsubscribe();
      throw i;
    }
  }, t;
})(Ut), vi = new hi(pi);
function mi(e) {
  return e && A(e.schedule);
}
function gi(e) {
  return e[e.length - 1];
}
function St(e) {
  return mi(gi(e)) ? e.pop() : void 0;
}
var Tt = (function(e) {
  return e && typeof e.length == "number" && typeof e != "function";
});
function vn(e) {
  return A(e?.then);
}
function mn(e) {
  return A(e[xt]);
}
function gn(e) {
  return Symbol.asyncIterator && A(e?.[Symbol.asyncIterator]);
}
function bn(e) {
  return new TypeError("You provided " + (e !== null && typeof e == "object" ? "an invalid object" : "'" + e + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function bi() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var yn = bi();
function wn(e) {
  return A(e?.[yn]);
}
function xn(e) {
  return Xr(this, arguments, function() {
    var n, r, i, o;
    return ln(this, function(s) {
      switch (s.label) {
        case 0:
          n = e.getReader(), s.label = 1;
        case 1:
          s.trys.push([1, , 9, 10]), s.label = 2;
        case 2:
          return [4, ge(n.read())];
        case 3:
          return r = s.sent(), i = r.value, o = r.done, o ? [4, ge(void 0)] : [3, 5];
        case 4:
          return [2, s.sent()];
        case 5:
          return [4, ge(i)];
        case 6:
          return [4, s.sent()];
        case 7:
          return s.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return n.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function Sn(e) {
  return A(e?.getReader);
}
function Q(e) {
  if (e instanceof L)
    return e;
  if (e != null) {
    if (mn(e))
      return yi(e);
    if (Tt(e))
      return wi(e);
    if (vn(e))
      return xi(e);
    if (gn(e))
      return Tn(e);
    if (wn(e))
      return Si(e);
    if (Sn(e))
      return Ti(e);
  }
  throw bn(e);
}
function yi(e) {
  return new L(function(t) {
    var n = e[xt]();
    if (A(n.subscribe))
      return n.subscribe(t);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function wi(e) {
  return new L(function(t) {
    for (var n = 0; n < e.length && !t.closed; n++)
      t.next(e[n]);
    t.complete();
  });
}
function xi(e) {
  return new L(function(t) {
    e.then(function(n) {
      t.closed || (t.next(n), t.complete());
    }, function(n) {
      return t.error(n);
    }).then(null, pn);
  });
}
function Si(e) {
  return new L(function(t) {
    var n, r;
    try {
      for (var i = we(e), o = i.next(); !o.done; o = i.next()) {
        var s = o.value;
        if (t.next(s), t.closed)
          return;
      }
    } catch (a) {
      n = { error: a };
    } finally {
      try {
        o && !o.done && (r = i.return) && r.call(i);
      } finally {
        if (n) throw n.error;
      }
    }
    t.complete();
  });
}
function Tn(e) {
  return new L(function(t) {
    Ci(e, t).catch(function(n) {
      return t.error(n);
    });
  });
}
function Ti(e) {
  return Tn(xn(e));
}
function Ci(e, t) {
  var n, r, i, o;
  return Jr(this, void 0, void 0, function() {
    var s, a;
    return ln(this, function(c) {
      switch (c.label) {
        case 0:
          c.trys.push([0, 5, 6, 11]), n = Zr(e), c.label = 1;
        case 1:
          return [4, n.next()];
        case 2:
          if (r = c.sent(), !!r.done) return [3, 4];
          if (s = r.value, t.next(s), t.closed)
            return [2];
          c.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return a = c.sent(), i = { error: a }, [3, 11];
        case 6:
          return c.trys.push([6, , 9, 10]), r && !r.done && (o = n.return) ? [4, o.call(n)] : [3, 8];
        case 7:
          c.sent(), c.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (i) throw i.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return t.complete(), [2];
      }
    });
  });
}
function ce(e, t, n, r, i) {
  r === void 0 && (r = 0), i === void 0 && (i = !1);
  var o = t.schedule(function() {
    n(), i ? e.add(this.schedule(null, r)) : this.unsubscribe();
  }, r);
  if (e.add(o), !i)
    return o;
}
function Cn(e, t) {
  return t === void 0 && (t = 0), B(function(n, r) {
    n.subscribe(z(r, function(i) {
      return ce(r, e, function() {
        return r.next(i);
      }, t);
    }, function() {
      return ce(r, e, function() {
        return r.complete();
      }, t);
    }, function(i) {
      return ce(r, e, function() {
        return r.error(i);
      }, t);
    }));
  });
}
function En(e, t) {
  return t === void 0 && (t = 0), B(function(n, r) {
    r.add(e.schedule(function() {
      return n.subscribe(r);
    }, t));
  });
}
function Ei(e, t) {
  return Q(e).pipe(En(t), Cn(t));
}
function Pi(e, t) {
  return Q(e).pipe(En(t), Cn(t));
}
function Oi(e, t) {
  return new L(function(n) {
    var r = 0;
    return t.schedule(function() {
      r === e.length ? n.complete() : (n.next(e[r++]), n.closed || this.schedule());
    });
  });
}
function Ai(e, t) {
  return new L(function(n) {
    var r;
    return ce(n, t, function() {
      r = e[yn](), ce(n, t, function() {
        var i, o, s;
        try {
          i = r.next(), o = i.value, s = i.done;
        } catch (a) {
          n.error(a);
          return;
        }
        s ? n.complete() : n.next(o);
      }, 0, !0);
    }), function() {
      return A(r?.return) && r.return();
    };
  });
}
function Pn(e, t) {
  if (!e)
    throw new Error("Iterable cannot be null");
  return new L(function(n) {
    ce(n, t, function() {
      var r = e[Symbol.asyncIterator]();
      ce(n, t, function() {
        r.next().then(function(i) {
          i.done ? n.complete() : n.next(i.value);
        });
      }, 0, !0);
    });
  });
}
function _i(e, t) {
  return Pn(xn(e), t);
}
function ki(e, t) {
  if (e != null) {
    if (mn(e))
      return Ei(e, t);
    if (Tt(e))
      return Oi(e, t);
    if (vn(e))
      return Pi(e, t);
    if (gn(e))
      return Pn(e, t);
    if (wn(e))
      return Ai(e, t);
    if (Sn(e))
      return _i(e, t);
  }
  throw bn(e);
}
function be(e, t) {
  return t ? ki(e, t) : Q(e);
}
function dt() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var n = St(e);
  return be(e, n);
}
function Li(e) {
  return e instanceof Date && !isNaN(e);
}
var Ii = yt(function(e) {
  return function(n) {
    n === void 0 && (n = null), e(this), this.message = "Timeout has occurred", this.name = "TimeoutError", this.info = n;
  };
});
function Mi(e, t) {
  var n = Li(e) ? { first: e } : typeof e == "number" ? { each: e } : e, r = n.first, i = n.each, o = n.with, s = o === void 0 ? Ri : o, a = n.scheduler, c = a === void 0 ? vi : a, u = n.meta, l = u === void 0 ? null : u;
  if (r == null && i == null)
    throw new TypeError("No timeout provided.");
  return B(function(f, v) {
    var d, m, p = null, g = 0, h = function(x) {
      m = ce(v, c, function() {
        try {
          d.unsubscribe(), Q(s({
            meta: l,
            lastValue: p,
            seen: g
          })).subscribe(v);
        } catch (T) {
          v.error(T);
        }
      }, x);
    };
    d = f.subscribe(z(v, function(x) {
      m?.unsubscribe(), g++, v.next(p = x), i > 0 && h(i);
    }, void 0, void 0, function() {
      m?.closed || m?.unsubscribe(), p = null;
    })), !g && h(r != null ? typeof r == "number" ? r : +r - c.now() : i);
  });
}
function Ri(e) {
  throw new Ii(e);
}
function _(e, t) {
  return B(function(n, r) {
    var i = 0;
    n.subscribe(z(r, function(o) {
      r.next(e.call(t, o, i++));
    }));
  });
}
var Di = Array.isArray;
function Fi(e, t) {
  return Di(t) ? e.apply(void 0, xe([], he(t))) : e(t);
}
function Ni(e) {
  return _(function(t) {
    return Fi(e, t);
  });
}
function $i(e, t, n, r, i, o, s, a) {
  var c = [], u = 0, l = 0, f = !1, v = function() {
    f && !c.length && !u && t.complete();
  }, d = function(p) {
    return u < r ? m(p) : c.push(p);
  }, m = function(p) {
    u++;
    var g = !1;
    Q(n(p, l++)).subscribe(z(t, function(h) {
      t.next(h);
    }, function() {
      g = !0;
    }, void 0, function() {
      if (g)
        try {
          u--;
          for (var h = function() {
            var x = c.shift();
            s || m(x);
          }; c.length && u < r; )
            h();
          v();
        } catch (x) {
          t.error(x);
        }
    }));
  };
  return e.subscribe(z(t, d, function() {
    f = !0, v();
  })), function() {
  };
}
function Ae(e, t, n) {
  return n === void 0 && (n = 1 / 0), A(t) ? Ae(function(r, i) {
    return _(function(o, s) {
      return t(r, o, i, s);
    })(Q(e(r, i)));
  }, n) : (typeof t == "number" && (n = t), B(function(r, i) {
    return $i(r, i, e, n);
  }));
}
function Ui(e) {
  return Ae(et, e);
}
function Wi() {
  return Ui(1);
}
function ze() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return Wi()(be(e, St(e)));
}
var Bi = ["addListener", "removeListener"], ji = ["addEventListener", "removeEventListener"], Vi = ["on", "off"];
function pt(e, t, n, r) {
  if (A(n) && (r = n, n = void 0), r)
    return pt(e, t, n).pipe(Ni(r));
  var i = he(Yi(e) ? ji.map(function(a) {
    return function(c) {
      return e[a](t, c, n);
    };
  }) : Hi(e) ? Bi.map(Wt(e, t)) : zi(e) ? Vi.map(Wt(e, t)) : [], 2), o = i[0], s = i[1];
  if (!o && Tt(e))
    return Ae(function(a) {
      return pt(a, t, n);
    })(Q(e));
  if (!o)
    throw new TypeError("Invalid event target");
  return new L(function(a) {
    var c = function() {
      for (var u = [], l = 0; l < arguments.length; l++)
        u[l] = arguments[l];
      return a.next(1 < u.length ? u : u[0]);
    };
    return o(c), function() {
      return s(c);
    };
  });
}
function Wt(e, t) {
  return function(n) {
    return function(r) {
      return e[n](t, r);
    };
  };
}
function Hi(e) {
  return A(e.addListener) && A(e.removeListener);
}
function zi(e) {
  return A(e.on) && A(e.off);
}
function Yi(e) {
  return A(e.addEventListener) && A(e.removeEventListener);
}
function tt(e, t) {
  return B(function(n, r) {
    var i = 0;
    n.subscribe(z(r, function(o) {
      return e.call(t, o, i++) && r.next(o);
    }));
  });
}
function qi(e, t, n, r, i) {
  return function(o, s) {
    var a = n, c = t, u = 0;
    o.subscribe(z(s, function(l) {
      var f = u++;
      c = a ? e(c, l, f) : (a = !0, l), s.next(c);
    }, i));
  };
}
function Ki(e, t) {
  return t === void 0 && (t = et), e = e ?? Gi, B(function(n, r) {
    var i, o = !0;
    n.subscribe(z(r, function(s) {
      var a = t(s);
      (o || !e(i, a)) && (o = !1, i = a, r.next(s));
    }));
  });
}
function Gi(e, t) {
  return e === t;
}
function Qi(e) {
  return B(function(t, n) {
    try {
      t.subscribe(n);
    } finally {
      n.add(e);
    }
  });
}
function $e(e, t) {
  return B(qi(e, t, arguments.length >= 2, !0));
}
function Ji(e) {
  e === void 0 && (e = {});
  var t = e.connector, n = t === void 0 ? function() {
    return new ie();
  } : t, r = e.resetOnError, i = r === void 0 ? !0 : r, o = e.resetOnComplete, s = o === void 0 ? !0 : o, a = e.resetOnRefCountZero, c = a === void 0 ? !0 : a;
  return function(u) {
    var l, f, v, d = 0, m = !1, p = !1, g = function() {
      f?.unsubscribe(), f = void 0;
    }, h = function() {
      g(), l = v = void 0, m = p = !1;
    }, x = function() {
      var T = l;
      h(), T?.unsubscribe();
    };
    return B(function(T, E) {
      d++, !p && !m && g();
      var S = v = v ?? n();
      E.add(function() {
        d--, d === 0 && !p && !m && (f = ot(x, c));
      }), S.subscribe(E), !l && d > 0 && (l = new Oe({
        next: function(b) {
          return S.next(b);
        },
        error: function(b) {
          p = !0, g(), f = ot(h, i, b), S.error(b);
        },
        complete: function() {
          m = !0, g(), f = ot(h, s), S.complete();
        }
      }), Q(T).subscribe(l));
    })(u);
  };
}
function ot(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  if (t === !0) {
    e();
    return;
  }
  if (t !== !1) {
    var i = new Oe({
      next: function() {
        i.unsubscribe(), e();
      }
    });
    return Q(t.apply(void 0, xe([], he(n)))).subscribe(i);
  }
}
function Xi(e) {
  return B(function(t, n) {
    var r = !1, i = z(n, function() {
      i?.unsubscribe(), r = !0;
    }, He);
    Q(e).subscribe(i), t.subscribe(z(n, function(o) {
      return r && n.next(o);
    }));
  });
}
function U() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var n = St(e);
  return B(function(r, i) {
    (n ? ze(e, r, n) : ze(e, r)).subscribe(i);
  });
}
function On(e, t) {
  return B(function(n, r) {
    var i = null, o = 0, s = !1, a = function() {
      return s && !i && r.complete();
    };
    n.subscribe(z(r, function(c) {
      i?.unsubscribe();
      var u = 0, l = o++;
      Q(e(c, l)).subscribe(i = z(r, function(f) {
        return r.next(t ? t(c, f, l, u++) : f);
      }, function() {
        i = null, a();
      }));
    }, function() {
      s = !0, a();
    }));
  });
}
function Bt(e) {
  return B(function(t, n) {
    Q(e).subscribe(z(n, function() {
      return n.complete();
    }, He)), !n.closed && t.subscribe(n);
  });
}
function Zi(e, t, n) {
  var r = A(e) || t || n ? { next: e, error: t, complete: n } : e;
  return r ? B(function(i, o) {
    var s;
    (s = r.subscribe) === null || s === void 0 || s.call(r);
    var a = !0;
    i.subscribe(z(o, function(c) {
      var u;
      (u = r.next) === null || u === void 0 || u.call(r, c), o.next(c);
    }, function() {
      var c;
      a = !1, (c = r.complete) === null || c === void 0 || c.call(r), o.complete();
    }, function(c) {
      var u;
      a = !1, (u = r.error) === null || u === void 0 || u.call(r, c), o.error(c);
    }, function() {
      var c, u;
      a && ((c = r.unsubscribe) === null || c === void 0 || c.call(r)), (u = r.finalize) === null || u === void 0 || u.call(r);
    }));
  }) : et;
}
var eo = Object.defineProperty, to = Object.defineProperties, no = Object.getOwnPropertyDescriptors, jt = Object.getOwnPropertySymbols, ro = Object.prototype.hasOwnProperty, io = Object.prototype.propertyIsEnumerable, Vt = (e, t) => (t = Symbol[e]) ? t : /* @__PURE__ */ Symbol.for("Symbol." + e), Ht = (e, t, n) => t in e ? eo(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, X = (e, t) => {
  for (var n in t || (t = {}))
    ro.call(t, n) && Ht(e, n, t[n]);
  if (jt)
    for (var n of jt(t))
      io.call(t, n) && Ht(e, n, t[n]);
  return e;
}, le = (e, t) => to(e, no(t)), H = (e, t, n) => new Promise((r, i) => {
  var o = (c) => {
    try {
      a(n.next(c));
    } catch (u) {
      i(u);
    }
  }, s = (c) => {
    try {
      a(n.throw(c));
    } catch (u) {
      i(u);
    }
  }, a = (c) => c.done ? r(c.value) : Promise.resolve(c.value).then(o, s);
  a((n = n.apply(e, t)).next());
}), oo = (e, t, n) => (t = e[Vt("asyncIterator")]) ? t.call(e) : (e = e[Vt("iterator")](), t = {}, n = (r, i) => (i = e[r]) && (t[r] = (o) => new Promise((s, a, c) => (o = i.call(e, o), c = o.done, Promise.resolve(o.value).then((u) => s({ value: u, done: c }), a)))), n("next"), n("return"), t), An = "lk";
function K(e) {
  return typeof e > "u" ? !1 : so(e) || ao(e);
}
function so(e) {
  var t;
  return e ? e.hasOwnProperty("participant") && e.hasOwnProperty("source") && e.hasOwnProperty("track") && typeof ((t = e.publication) == null ? void 0 : t.track) < "u" : !1;
}
function ao(e) {
  return e ? e.hasOwnProperty("participant") && e.hasOwnProperty("source") && e.hasOwnProperty("publication") && typeof e.publication < "u" : !1;
}
function _e(e) {
  return e ? e.hasOwnProperty("participant") && e.hasOwnProperty("source") && typeof e.publication > "u" : !1;
}
function V(e) {
  if (typeof e == "string" || typeof e == "number")
    return `${e}`;
  if (_e(e))
    return `${e.participant.identity}_${e.source}_placeholder`;
  if (K(e))
    return `${e.participant.identity}_${e.publication.source}_${e.publication.trackSid}`;
  throw new Error(`Can't generate a id for the given track reference: ${e}`);
}
function ss(e, t) {
  return e === void 0 || t === void 0 ? !1 : K(e) && K(t) ? e.publication.trackSid === t.publication.trackSid : V(e) === V(t);
}
function as(e, t) {
  return typeof t > "u" ? !1 : K(e) ? t.some(
    (n) => n.participant.identity === e.participant.identity && K(n) && n.publication.trackSid === e.publication.trackSid
  ) : _e(e) ? t.some(
    (n) => n.participant.identity === e.participant.identity && _e(n) && n.source === e.source
  ) : !1;
}
function co(e, t) {
  return _e(e) && K(t) && t.participant.identity === e.participant.identity && t.source === e.source;
}
function cs() {
  const e = document.createElement("p");
  e.style.width = "100%", e.style.height = "200px";
  const t = document.createElement("div");
  t.style.position = "absolute", t.style.top = "0px", t.style.left = "0px", t.style.visibility = "hidden", t.style.width = "200px", t.style.height = "150px", t.style.overflow = "hidden", t.appendChild(e), document.body.appendChild(t);
  const n = e.offsetWidth;
  t.style.overflow = "scroll";
  let r = e.offsetWidth;
  return n === r && (r = t.clientWidth), document.body.removeChild(t), n - r;
}
function us() {
  return typeof document < "u";
}
function uo(e) {
  e = X({}, e);
  const t = "(?:(?:[a-z]+:)?//)?", n = "(?:\\S+(?::\\S*)?@)?", r = new RegExp(
    "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}",
    "g"
  ).source, u = `(?:${t}|www\\.)${n}(?:localhost|${r}|(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))\\.?)(?::\\d{2,5})?(?:[/?#][^\\s"]*)?`;
  return e.exact ? new RegExp(`(?:^${u}$)`, "i") : new RegExp(u, "ig");
}
var zt = "[^\\.\\s@:](?:[^\\s@:]*[^\\s@:\\.])?@[^\\.\\s@]+(?:\\.[^\\.\\s@]+)*";
function lo({ exact: e } = {}) {
  return e ? new RegExp(`^${zt}$`) : new RegExp(zt, "g");
}
function ls(e, t, n) {
  return Br(e, t, () => H(null, null, function* () {
    const { x: i, y: o } = yield zr(e, t, {
      placement: "top",
      middleware: [jr(6), Hr(), Vr({ padding: 5 })]
    });
    n?.(i, o);
  }));
}
function fs(e, t) {
  return !e.contains(t.target);
}
var ds = () => ({
  email: lo(),
  url: uo({})
});
function ps(e, t) {
  const n = Object.entries(t).map(
    ([o, s], a) => Array.from(e.matchAll(s)).map(({ index: c, 0: u }) => ({
      type: o,
      weight: a,
      content: u,
      index: c ?? 0
    }))
  ).flat().sort((o, s) => {
    const a = o.index - s.index;
    return a !== 0 ? a : o.weight - s.weight;
  }).filter(({ index: o }, s, a) => {
    if (s === 0) return !0;
    const c = a[s - 1];
    return c.index + c.content.length <= o;
  }), r = [];
  let i = 0;
  for (const { type: o, content: s, index: a } of n)
    a > i && r.push(e.substring(i, a)), r.push({ type: o, content: s }), i = a + s.length;
  return e.length > i && r.push(e.substring(i)), r;
}
var fo = [
  y.ConnectionStateChanged,
  y.RoomMetadataChanged,
  y.ActiveSpeakersChanged,
  y.ConnectionQualityChanged,
  y.ParticipantConnected,
  y.ParticipantDisconnected,
  y.ParticipantPermissionsChanged,
  y.ParticipantMetadataChanged,
  y.ParticipantNameChanged,
  y.ParticipantAttributesChanged,
  y.TrackMuted,
  y.TrackUnmuted,
  y.TrackPublished,
  y.TrackUnpublished,
  y.TrackStreamStateChanged,
  y.TrackSubscriptionFailed,
  y.TrackSubscriptionPermissionChanged,
  y.TrackSubscriptionStatusChanged
], _n = [
  ...fo,
  y.LocalTrackPublished,
  y.LocalTrackUnpublished
], po = [
  w.TrackPublished,
  w.TrackUnpublished,
  w.TrackMuted,
  w.TrackUnmuted,
  w.TrackStreamStateChanged,
  w.TrackSubscribed,
  w.TrackUnsubscribed,
  w.TrackSubscriptionPermissionChanged,
  w.TrackSubscriptionFailed,
  w.LocalTrackPublished,
  w.LocalTrackUnpublished
], ho = [
  w.ConnectionQualityChanged,
  w.IsSpeakingChanged,
  w.ParticipantMetadataChanged,
  w.ParticipantPermissionsChanged,
  w.TrackMuted,
  w.TrackUnmuted,
  w.TrackPublished,
  w.TrackUnpublished,
  w.TrackStreamStateChanged,
  w.TrackSubscriptionFailed,
  w.TrackSubscriptionPermissionChanged,
  w.TrackSubscriptionStatusChanged
], kn = [
  ...ho,
  w.LocalTrackPublished,
  w.LocalTrackUnpublished
], I = Qr.getLogger("lk-components-js");
I.setDefaultLevel("WARN");
function hs(e, t = {}) {
  var n;
  I.setLevel(e), Gn((n = t.liveKitClientLogLevel) != null ? n : e);
}
function vs(e, t = {}) {
  var n;
  const r = I.methodFactory;
  I.methodFactory = (i, o, s) => {
    const a = r(i, o, s), c = Ct[i], u = c >= o && c < Ct.silent;
    return (l, f) => {
      f ? a(l, f) : a(l), u && e(c, l, f);
    };
  }, I.setLevel(I.getLevel()), Kn((n = t.liveKitClientLogExtension) != null ? n : e);
}
var ms = [
  {
    columns: 1,
    rows: 1
  },
  {
    columns: 1,
    rows: 2,
    orientation: "portrait"
  },
  {
    columns: 2,
    rows: 1,
    orientation: "landscape"
  },
  {
    columns: 2,
    rows: 2,
    minWidth: 560
  },
  {
    columns: 3,
    rows: 3,
    minWidth: 700
  },
  {
    columns: 4,
    rows: 4,
    minWidth: 960
  },
  {
    columns: 5,
    rows: 5,
    minWidth: 1100
  }
];
function vo(e, t, n, r) {
  if (e.length < 1)
    throw new Error("At least one grid layout definition must be provided.");
  const i = mo(e);
  if (n <= 0 || r <= 0)
    return i[0];
  let o = 0;
  const s = n / r > 1 ? "landscape" : "portrait";
  let a = i.find((c, u, l) => {
    o = u;
    const f = l.findIndex((v, d) => {
      const m = !v.orientation || v.orientation === s, p = d > u, g = v.maxTiles === c.maxTiles;
      return p && g && m;
    }) !== -1;
    return c.maxTiles >= t && !f;
  });
  if (a === void 0)
    if (a = i[i.length - 1], a)
      I.warn(
        `No layout found for: participantCount: ${t}, width/height: ${n}/${r} fallback to biggest available layout (${a}).`
      );
    else
      throw new Error("No layout or fallback layout found.");
  if ((n < a.minWidth || r < a.minHeight) && o > 0) {
    const c = i[o - 1];
    a = vo(
      i.slice(0, o),
      c.maxTiles,
      n,
      r
    );
  }
  return a;
}
function mo(e) {
  return [...e].map((t) => {
    var n, r;
    return {
      name: `${t.columns}x${t.rows}`,
      columns: t.columns,
      rows: t.rows,
      maxTiles: t.columns * t.rows,
      minWidth: (n = t.minWidth) != null ? n : 0,
      minHeight: (r = t.minHeight) != null ? r : 0,
      orientation: t.orientation
    };
  }).sort((t, n) => t.maxTiles !== n.maxTiles ? t.maxTiles - n.maxTiles : t.minWidth !== 0 || n.minWidth !== 0 ? t.minWidth - n.minWidth : t.minHeight !== 0 || n.minHeight !== 0 ? t.minHeight - n.minHeight : 0);
}
function gs() {
  return typeof navigator < "u" && navigator.mediaDevices && !!navigator.mediaDevices.getDisplayMedia;
}
function bs(e, t) {
  var n;
  return le(X({}, e), {
    receivedAtMediaTimestamp: (n = t.rtpTimestamp) != null ? n : 0,
    receivedAt: t.timestamp
  });
}
function ys(e, t, n) {
  return [...e, ...t].reduceRight((r, i) => (r.find((o) => o.id === i.id) || r.unshift(i), r), []).slice(0 - n);
}
var go = /* @__PURE__ */ ((e) => (e.AgentState = "lk.agent.state", e.PublishOnBehalf = "lk.publish_on_behalf", e.TranscriptionFinal = "lk.transcription_final", e.TranscriptionSegmentId = "lk.segment_id", e.TranscribedTrackId = "lk.transcribed_track_id", e))(go || {}), Ln = [], In = {
  showChat: !1,
  unreadMessages: 0,
  showSettings: !1
};
function bo(e) {
  return typeof e == "object";
}
function ws(e) {
  return Array.isArray(e) && e.filter(bo).length > 0;
}
function Mn(e, t) {
  return t.audioLevel - e.audioLevel;
}
function Rn(e, t) {
  return e.isSpeaking === t.isSpeaking ? 0 : e.isSpeaking ? -1 : 1;
}
function Dn(e, t) {
  var n, r, i, o;
  return e.lastSpokeAt !== void 0 || t.lastSpokeAt !== void 0 ? ((r = (n = t.lastSpokeAt) == null ? void 0 : n.getTime()) != null ? r : 0) - ((o = (i = e.lastSpokeAt) == null ? void 0 : i.getTime()) != null ? o : 0) : 0;
}
function Ye(e, t) {
  var n, r, i, o;
  return ((r = (n = e.joinedAt) == null ? void 0 : n.getTime()) != null ? r : 0) - ((o = (i = t.joinedAt) == null ? void 0 : i.getTime()) != null ? o : 0);
}
function yo(e, t) {
  return K(e) ? K(t) ? 0 : -1 : K(t) ? 1 : 0;
}
function wo(e, t) {
  const n = e.participant.isCameraEnabled, r = t.participant.isCameraEnabled;
  return n !== r ? n ? -1 : 1 : 0;
}
function xs(e) {
  const t = [], n = [], r = [], i = [];
  e.forEach((a) => {
    a.participant.isLocal && a.source === $.Source.Camera ? t.push(a) : a.source === $.Source.ScreenShare ? n.push(a) : a.source === $.Source.Camera ? r.push(a) : i.push(a);
  });
  const o = xo(n), s = So(r);
  return [...t, ...o, ...s, ...i];
}
function xo(e) {
  const t = [], n = [];
  return e.forEach((i) => {
    i.participant.isLocal ? t.push(i) : n.push(i);
  }), t.sort((i, o) => Ye(i.participant, o.participant)), n.sort((i, o) => Ye(i.participant, o.participant)), [...n, ...t];
}
function So(e) {
  const t = [], n = [];
  return e.forEach((r) => {
    r.participant.isLocal ? t.push(r) : n.push(r);
  }), n.sort((r, i) => r.participant.isSpeaking && i.participant.isSpeaking ? Mn(r.participant, i.participant) : r.participant.isSpeaking !== i.participant.isSpeaking ? Rn(r.participant, i.participant) : r.participant.lastSpokeAt !== i.participant.lastSpokeAt ? Dn(r.participant, i.participant) : K(r) !== K(i) ? yo(r, i) : r.participant.isCameraEnabled !== i.participant.isCameraEnabled ? wo(r, i) : Ye(r.participant, i.participant)), [...t, ...n];
}
function Ss(e) {
  const t = [...e];
  t.sort((r, i) => {
    if (r.isSpeaking && i.isSpeaking)
      return Mn(r, i);
    if (r.isSpeaking !== i.isSpeaking)
      return Rn(r, i);
    if (r.lastSpokeAt !== i.lastSpokeAt)
      return Dn(r, i);
    const o = r.videoTrackPublications.size > 0, s = i.videoTrackPublications.size > 0;
    return o !== s ? o ? -1 : 1 : Ye(r, i);
  });
  const n = t.find((r) => r.isLocal);
  if (n) {
    const r = t.indexOf(n);
    r >= 0 && (t.splice(r, 1), t.length > 0 ? t.splice(0, 0, n) : t.push(n));
  }
  return t;
}
function To(e, t) {
  return e.reduce(
    (n, r, i) => i % t === 0 ? [...n, [r]] : [...n.slice(0, -1), [...n.slice(-1)[0], r]],
    []
  );
}
function Yt(e, t) {
  const n = Math.max(e.length, t.length);
  return new Array(n).fill([]).map((r, i) => [e[i], t[i]]);
}
function qe(e, t, n) {
  return e.filter((r) => !t.map((i) => n(i)).includes(n(r)));
}
function ht(e) {
  return e.map((t) => typeof t == "string" || typeof t == "number" ? `${t}` : V(t));
}
function Co(e, t) {
  return {
    dropped: qe(e, t, V),
    added: qe(t, e, V)
  };
}
function Eo(e) {
  return e.added.length !== 0 || e.dropped.length !== 0;
}
function vt(e, t) {
  const n = t.findIndex(
    (r) => V(r) === V(e)
  );
  if (n === -1)
    throw new Error(
      `Element not part of the array: ${V(
        e
      )} not in ${ht(t)}`
    );
  return n;
}
function Po(e, t, n) {
  const r = vt(e, n), i = vt(t, n);
  return n.splice(r, 1, t), n.splice(i, 1, e), n;
}
function Oo(e, t) {
  const n = vt(e, t);
  return t.splice(n, 1), t;
}
function Ao(e, t) {
  return [...t, e];
}
function st(e, t) {
  return To(e, t);
}
function Ts(e, t, n) {
  let r = _o(e, t);
  if (r.length < t.length) {
    const s = qe(t, r, V);
    r = [...r, ...s];
  }
  const i = st(r, n), o = st(t, n);
  if (Yt(i, o).forEach(([s, a], c) => {
    if (s && a) {
      const u = st(r, n)[c], l = Co(u, a);
      Eo(l) && (I.debug(
        `Detected visual changes on page: ${c}, current: ${ht(
          s
        )}, next: ${ht(a)}`,
        { changes: l }
      ), l.added.length === l.dropped.length && Yt(l.added, l.dropped).forEach(([f, v]) => {
        if (f && v)
          r = Po(f, v, r);
        else
          throw new Error(
            `For a swap action we need a addition and a removal one is missing: ${f}, ${v}`
          );
      }), l.added.length === 0 && l.dropped.length > 0 && l.dropped.forEach((f) => {
        r = Oo(f, r);
      }), l.added.length > 0 && l.dropped.length === 0 && l.added.forEach((f) => {
        r = Ao(f, r);
      }));
    }
  }), r.length > t.length) {
    const s = qe(r, t, V);
    r = r.filter(
      (a) => !s.map(V).includes(V(a))
    );
  }
  return r;
}
function _o(e, t) {
  return e.map((n) => {
    const r = t.find(
      (i) => (
        // If the IDs match or ..
        V(n) === V(i) || // ... if the current item is a placeholder and the new item is the track reference can replace it.
        typeof n != "number" && _e(n) && K(i) && co(n, i)
      )
    );
    return r ?? n;
  });
}
function Y(e) {
  return `${An}-${e}`;
}
function Cs(e) {
  const t = qt(e), n = Fn(e.participant).pipe(
    _(() => qt(e)),
    U(t)
  );
  return { className: Y(
    e.source === $.Source.Camera || e.source === $.Source.ScreenShare ? "participant-media-video" : "participant-media-audio"
  ), trackObserver: n };
}
function qt(e) {
  if (K(e))
    return e.publication;
  {
    const { source: t, name: n, participant: r } = e;
    if (t && n)
      return r.getTrackPublications().find((i) => i.source === t && i.trackName === n);
    if (n)
      return r.getTrackPublicationByName(n);
    if (t)
      return r.getTrackPublication(t);
    throw new Error("At least one of source and name needs to be defined");
  }
}
function ve(e, ...t) {
  return new L((r) => {
    const i = () => {
      r.next(e);
    };
    return t.forEach((s) => {
      e.on(s, i);
    }), () => {
      t.forEach((s) => {
        e.off(s, i);
      });
    };
  }).pipe(U(e));
}
function Te(e, t) {
  return new L((r) => {
    const i = (...s) => {
      r.next(s);
    };
    return e.on(t, i), () => {
      e.off(t, i);
    };
  });
}
function Es(e) {
  return Te(e, y.ConnectionStateChanged).pipe(
    _(([t]) => t),
    U(e.state)
  );
}
function Ps(e) {
  return ve(
    e,
    y.RoomMetadataChanged,
    y.ConnectionStateChanged
  ).pipe(
    _((n) => ({ name: n.name, metadata: n.metadata }))
  );
}
function Os(e) {
  return Te(e, y.ActiveSpeakersChanged).pipe(
    _(([t]) => t)
  );
}
function As(e, t, n = !0) {
  const r = new L((o) => {
    Et.getLocalDevices(e, n).then((s) => {
      o.next(s), o.complete();
    }).catch((s) => {
      t?.(s), o.next([]), o.complete();
    });
  }), i = new L((o) => {
    var s;
    const a = () => H(null, null, function* () {
      try {
        const c = yield Et.getLocalDevices(e, n);
        o.next(c);
      } catch (c) {
        t?.(c);
      }
    });
    if (typeof window < "u") {
      if (!window.isSecureContext)
        throw new Error(
          "Accessing media devices is available only in secure contexts (HTTPS and localhost), in some or all supporting browsers. See: https://developer.mozilla.org/en-US/docs/Web/API/Navigator/mediaDevices"
        );
      (s = navigator?.mediaDevices) == null || s.addEventListener("devicechange", a);
    }
    return () => {
      var c;
      (c = navigator?.mediaDevices) == null || c.removeEventListener("devicechange", a);
    };
  });
  return ze(r, i);
}
function ko(e) {
  return Te(e, y.DataReceived);
}
function Lo(e) {
  return ve(e, y.AudioPlaybackStatusChanged).pipe(
    _((n) => ({ canPlayAudio: n.canPlaybackAudio }))
  );
}
function Io(e) {
  return ve(e, y.VideoPlaybackStatusChanged).pipe(
    _((n) => ({ canPlayVideo: n.canPlaybackVideo }))
  );
}
function Mo(e, t) {
  return Te(e, y.ActiveDeviceChanged).pipe(
    tt(([n]) => n === t),
    _(([n, r]) => (I.debug("activeDeviceObservable | RoomEvent.ActiveDeviceChanged", { kind: n, deviceId: r }), r))
  );
}
function _s(e, t) {
  return Te(e, y.ParticipantEncryptionStatusChanged).pipe(
    tt(
      ([, n]) => t?.identity === n?.identity || !n && t?.identity === e.localParticipant.identity
    ),
    _(([n]) => n),
    U(
      t?.isLocal ? t.isE2EEEnabled : !!t?.isEncrypted
    )
  );
}
function ks(e) {
  return Te(e, y.RecordingStatusChanged).pipe(
    _(([t]) => t),
    U(e.isRecording)
  );
}
function Ce(e, ...t) {
  return new L((r) => {
    const i = () => {
      r.next(e);
    };
    return t.forEach((s) => {
      e.on(s, i);
    }), () => {
      t.forEach((s) => {
        e.off(s, i);
      });
    };
  }).pipe(U(e));
}
function Fn(e) {
  return Ce(
    e,
    w.TrackMuted,
    w.TrackUnmuted,
    w.ParticipantPermissionsChanged,
    // ParticipantEvent.IsSpeakingChanged,
    w.TrackPublished,
    w.TrackUnpublished,
    w.LocalTrackPublished,
    w.LocalTrackUnpublished,
    w.MediaDevicesError,
    w.TrackSubscriptionStatusChanged
    // ParticipantEvent.ConnectionQualityChanged,
  ).pipe(
    _((n) => {
      const { isMicrophoneEnabled: r, isCameraEnabled: i, isScreenShareEnabled: o } = n, s = n.getTrackPublication($.Source.Microphone), a = n.getTrackPublication($.Source.Camera);
      return {
        isCameraEnabled: i,
        isMicrophoneEnabled: r,
        isScreenShareEnabled: o,
        cameraTrack: a,
        microphoneTrack: s,
        participant: n
      };
    })
  );
}
function Ro(e) {
  return e ? Ce(
    e,
    w.ParticipantMetadataChanged,
    w.ParticipantNameChanged
  ).pipe(
    _(({ name: n, identity: r, metadata: i }) => ({
      name: n,
      identity: r,
      metadata: i
    })),
    U({
      name: e.name,
      identity: e.identity,
      metadata: e.metadata
    })
  ) : void 0;
}
function Do(e) {
  return nt(
    e,
    w.ConnectionQualityChanged
  ).pipe(
    _(([n]) => n),
    U(e.connectionQuality)
  );
}
function nt(e, t) {
  return new L((r) => {
    const i = (...s) => {
      r.next(s);
    };
    return e.on(t, i), () => {
      e.off(t, i);
    };
  });
}
function Fo(e) {
  var t, n, r, i;
  return Ce(
    e.participant,
    w.TrackMuted,
    w.TrackUnmuted,
    w.TrackSubscribed,
    w.TrackUnsubscribed,
    w.LocalTrackPublished,
    w.LocalTrackUnpublished
  ).pipe(
    _((o) => {
      var s, a;
      const c = (s = e.publication) != null ? s : o.getTrackPublication(e.source);
      return (a = c?.isMuted) != null ? a : !0;
    }),
    U(
      (i = (r = (t = e.publication) == null ? void 0 : t.isMuted) != null ? r : (n = e.participant.getTrackPublication(e.source)) == null ? void 0 : n.isMuted) != null ? i : !0
    )
  );
}
function Ls(e) {
  return nt(e, w.IsSpeakingChanged).pipe(
    _(([t]) => t)
  );
}
function Is(e, t = {}) {
  var n;
  let r;
  const i = new L((c) => (r = c, () => a.unsubscribe())).pipe(U(Array.from(e.remoteParticipants.values()))), o = (n = t.additionalRoomEvents) != null ? n : _n, s = Array.from(
    /* @__PURE__ */ new Set([
      y.ParticipantConnected,
      y.ParticipantDisconnected,
      y.ConnectionStateChanged,
      ...o
    ])
  ), a = ve(e, ...s).subscribe(
    (c) => r?.next(Array.from(c.remoteParticipants.values()))
  );
  return e.remoteParticipants.size > 0 && r?.next(Array.from(e.remoteParticipants.values())), i;
}
function Ms(e, t, n = {}) {
  var r;
  const i = (r = n.additionalEvents) != null ? r : kn;
  return ve(
    e,
    y.ParticipantConnected,
    y.ParticipantDisconnected,
    y.ConnectionStateChanged
  ).pipe(
    On((s) => {
      const a = s.getParticipantByIdentity(t);
      return a ? Ce(a, ...i) : new L((c) => c.next(void 0));
    }),
    U(e.getParticipantByIdentity(t))
  );
}
function Rs(e) {
  return nt(
    e,
    w.ParticipantPermissionsChanged
  ).pipe(
    _(() => e.permissions),
    U(e.permissions)
  );
}
function Ds(e, { kind: t, identity: n }, r = {}) {
  var i;
  const o = (i = r.additionalEvents) != null ? i : kn, s = (c) => {
    let u = !0;
    return t && (u = u && c.kind === t), n && (u = u && c.identity === n), u;
  };
  return ve(
    e,
    y.ParticipantConnected,
    y.ParticipantDisconnected,
    y.ConnectionStateChanged
  ).pipe(
    On((c) => {
      const u = Array.from(c.remoteParticipants.values()).find(
        (l) => s(l)
      );
      return u ? Ce(u, ...o) : new L((l) => l.next(void 0));
    }),
    U(Array.from(e.remoteParticipants.values()).find((c) => s(c)))
  );
}
function Fs(e) {
  return typeof e > "u" ? new L() : nt(e, w.AttributesChanged).pipe(
    _(([t]) => ({
      changed: t,
      attributes: e.attributes
    })),
    U({ changed: e.attributes, attributes: e.attributes })
  );
}
function Ns(e, t, n, r, i) {
  const { localParticipant: o } = t, s = (f, v) => {
    let d = !1;
    switch (f) {
      case $.Source.Camera:
        d = v.isCameraEnabled;
        break;
      case $.Source.Microphone:
        d = v.isMicrophoneEnabled;
        break;
      case $.Source.ScreenShare:
        d = v.isScreenShareEnabled;
        break;
    }
    return d;
  }, a = Fn(o).pipe(
    _((f) => s(e, f.participant)),
    U(s(e, o))
  ), c = new ie(), u = (f, v) => H(null, null, function* () {
    try {
      switch (v ?? (v = n), c.next(!0), e) {
        case $.Source.Camera:
          return yield o.setCameraEnabled(
            f ?? !o.isCameraEnabled,
            v,
            r
          ), o.isCameraEnabled;
        case $.Source.Microphone:
          return yield o.setMicrophoneEnabled(
            f ?? !o.isMicrophoneEnabled,
            v,
            r
          ), o.isMicrophoneEnabled;
        case $.Source.ScreenShare:
          return yield o.setScreenShareEnabled(
            f ?? !o.isScreenShareEnabled,
            v,
            r
          ), o.isScreenShareEnabled;
        default:
          throw new TypeError("Tried to toggle unsupported source");
      }
    } catch (d) {
      if (i && d instanceof Error) {
        i?.(d);
        return;
      } else
        throw d;
    } finally {
      c.next(!1);
    }
  });
  return {
    className: Y("button"),
    toggle: u,
    enabledObserver: a,
    pendingObserver: c.asObservable()
  };
}
function $s() {
  let e = !1;
  const t = new ie(), n = new ie(), r = (o) => H(null, null, function* () {
    n.next(!0), e = o ?? !e, t.next(e), n.next(!1);
  });
  return {
    className: Y("button"),
    toggle: r,
    enabledObserver: t.asObservable(),
    pendingObserver: n.asObservable()
  };
}
function Us(e, t, n) {
  const r = new hn(void 0), i = Mo(t, e), o = (a, ...c) => H(null, [a, ...c], function* (u, l = {}) {
    var f, v, d;
    if (t) {
      const m = Qn();
      if (e === "audiooutput" && (m?.name === "Safari" || m?.os === "iOS")) {
        I.warn("Switching audio output device is not supported on Safari and iOS.");
        return;
      }
      I.debug(`Switching active device of kind "${e}" with id ${u}.`), yield t.switchActiveDevice(e, u, l.exact);
      const p = (f = t.getActiveDevice(e)) != null ? f : u;
      p !== u && u !== "default" && I.info(
        `We tried to select the device with id (${u}), but the browser decided to select the device with id (${p}) instead.`
      );
      let g;
      e === "audioinput" ? g = (v = t.localParticipant.getTrackPublication($.Source.Microphone)) == null ? void 0 : v.track : e === "videoinput" && (g = (d = t.localParticipant.getTrackPublication($.Source.Camera)) == null ? void 0 : d.track);
      const h = u === "default" && !g || u === "default" && g?.mediaStreamTrack.label.startsWith("Default");
      r.next(h ? u : p);
    }
  });
  return {
    className: Y("media-device-select"),
    activeDeviceObservable: i,
    setActiveMediaDevice: o
  };
}
function Ws(e) {
  const t = (r) => {
    e.disconnect(r);
  };
  return { className: Y("disconnect-button"), disconnect: t };
}
function Bs(e) {
  const t = Y("connection-quality"), n = Do(e);
  return { className: t, connectionQualityObserver: n };
}
function js(e) {
  let t = "track-muted-indicator-camera";
  switch (e.source) {
    case $.Source.Camera:
      t = "track-muted-indicator-camera";
      break;
    case $.Source.Microphone:
      t = "track-muted-indicator-microphone";
      break;
  }
  const n = Y(t), r = Fo(e);
  return { className: n, mediaMutedObserver: r };
}
function Vs(e) {
  return { className: "lk-participant-name", infoObserver: Ro(e) };
}
function Hs() {
  return {
    className: Y("participant-tile")
  };
}
var No = {
  CHAT: "lk.chat",
  TRANSCRIPTION: "lk.transcription"
}, $o = {
  CHAT: "lk-chat-topic"
};
function Nn(e, t) {
  return H(this, arguments, function* (n, r, i = {}) {
    const { reliable: o, destinationIdentities: s, topic: a } = i;
    yield n.publishData(r, {
      destinationIdentities: s,
      topic: a,
      reliable: o
    });
  });
}
function Uo(e, t, n) {
  const r = Array.isArray(t) ? t : [t], i = ko(e).pipe(
    tt(
      ([, , , c]) => t === void 0 || c !== void 0 && r.includes(c)
    ),
    _(([c, u, , l]) => {
      const f = {
        payload: c,
        topic: l,
        from: u
      };
      return n?.(f), f;
    })
  );
  let o;
  const s = new L((c) => {
    o = c;
  });
  return { messageObservable: i, isSendingObservable: s, send: (c, ...u) => H(null, [c, ...u], function* (l, f = {}) {
    o.next(!0);
    try {
      yield Nn(e.localParticipant, l, X({ topic: r[0] }, f));
    } finally {
      o.next(!1);
    }
  }) };
}
var Wo = class {
  constructor(e, t) {
    this._isResolved = !1, this.onFinally = t, this.promise = new Promise((n, r) => H(this, null, function* () {
      this.resolve = n, this.reject = r, e && (yield e(n, r));
    })).finally(() => {
      var n;
      this._isResolved = !0, (n = this.onFinally) == null || n.call(this);
    });
  }
  get isResolved() {
    return this._isResolved;
  }
}, Re = /* @__PURE__ */ new WeakMap(), De = /* @__PURE__ */ new Map();
function Bo(e) {
  return e.ignoreLegacy == !0;
}
var jo = (e) => JSON.parse(new TextDecoder().decode(e)), Vo = (e) => new TextEncoder().encode(JSON.stringify(e));
function zs(e, t) {
  var n, r, i, o, s, a;
  const c = () => {
    var S, b, P;
    return ((S = e.serverInfo) == null ? void 0 : S.edition) === 1 || !!((b = e.serverInfo) != null && b.version) && Jn((P = e.serverInfo) == null ? void 0 : P.version, "1.8.2") > 0;
  }, u = new ie(), l = (n = t?.channelTopic) != null ? n : No.CHAT, f = (r = t?.channelTopic) != null ? r : $o.CHAT;
  let v = !1;
  Re.has(e) || (v = !0);
  const d = (i = Re.get(e)) != null ? i : /* @__PURE__ */ new Map(), m = (o = d.get(l)) != null ? o : new ie();
  d.set(l, m), Re.set(e, d);
  const p = (s = t?.messageDecoder) != null ? s : jo;
  if (v) {
    e.registerTextStreamHandler(l, (b, P) => H(null, null, function* () {
      const { id: M, timestamp: R, attributes: W, attachedStreamIds: C } = b.info, O = new Map(
        (C ?? []).map((k) => [
          k,
          new Wo()
        ])
      );
      De.set(M, O), be(b).pipe(
        $e((k, F) => k + F),
        Ae((k) => O.size === 0 ? dt({ chunk: k, attachedFiles: [] }) : be(O.values()).pipe(
          Ae((F) => be(F.promise)),
          $e(
            (F, G) => [...F, new File(G.buffer, G.fileName)],
            []
          ),
          _((F) => ({ chunk: k, attachedFiles: F }))
        )),
        _(({ chunk: k, attachedFiles: F }) => ({
          id: M,
          timestamp: R,
          message: k,
          from: e.getParticipantByIdentity(P.identity),
          type: "chatMessage",
          attributes: W,
          attachedFiles: F
          // editTimestamp: type === 'update' ? timestamp : undefined,
        })),
        Qi(() => De.delete(M))
      ).subscribe({
        next: (k) => m.next(k)
      });
    })), e.registerByteStreamHandler(l, (b) => H(null, null, function* () {
      var P, M;
      const { id: R } = b.info, W = Array.from(De).find(
        ([, N]) => N.has(R)
      );
      if (!W)
        return;
      const C = W[0], O = [];
      try {
        for (var j = oo(b), k, F, G; k = !(F = yield j.next()).done; k = !1) {
          const N = F.value;
          O.push(N);
        }
      } catch (N) {
        G = [N];
      } finally {
        try {
          k && (F = j.return) && (yield F.call(j));
        } finally {
          if (G)
            throw G[0];
        }
      }
      const J = (P = De.get(C)) == null ? void 0 : P.get(R);
      J && ((M = J.resolve) == null || M.call(J, {
        fileName: b.info.name,
        buffer: O
      }));
    }));
    const { messageObservable: S } = Uo(e, [f]);
    S.pipe(
      _((b) => {
        const P = p(b.payload);
        return Bo(P) ? void 0 : le(X({}, P), {
          type: "chatMessage",
          from: b.from
        });
      }),
      tt((b) => !!b),
      Bt(u)
    ).subscribe(m);
  }
  const g = m.pipe(
    $e((S, b) => {
      if ("id" in b && S.find((P) => {
        var M, R;
        return ((M = P.from) == null ? void 0 : M.identity) === ((R = b.from) == null ? void 0 : R.identity) && P.id === b.id;
      })) {
        const P = S.findIndex((M) => M.id === b.id);
        if (P > -1) {
          const M = S[P];
          S[P] = le(X({}, b), {
            timestamp: M.timestamp,
            editTimestamp: b.timestamp
          });
        }
        return [...S];
      }
      return [...S, b];
    }, []),
    Bt(u)
  ), h = new hn(!1), x = (a = t?.messageEncoder) != null ? a : Vo, T = (S, b) => H(null, null, function* () {
    var P;
    b || (b = {}), (P = b.topic) != null || (b.topic = l), h.next(!0);
    try {
      const R = {
        id: (yield e.localParticipant.sendText(S, b)).id,
        timestamp: Date.now(),
        message: S
      }, W = le(X({}, R), {
        attachedFiles: b.attachments
      }), C = le(X({}, W), {
        type: "chatMessage",
        from: e.localParticipant,
        attributes: b.attributes
      });
      m.next(C);
      const O = x(le(X({}, R), {
        ignoreLegacy: c()
      }));
      try {
        yield Nn(e.localParticipant, O, {
          reliable: !0,
          topic: f
        });
      } catch (j) {
        I.info("could not send message in legacy chat format", j);
      }
      return C;
    } finally {
      h.next(!1);
    }
  });
  function E() {
    u.next(), u.complete(), m.complete(), Re.delete(e), e.unregisterTextStreamHandler(l), e.unregisterByteStreamHandler(l);
  }
  return e.once(y.Disconnected, E), {
    messageObservable: g,
    isSendingObservable: h,
    send: T
  };
}
function Ys() {
  const e = (n) => H(null, null, function* () {
    I.info("Start Audio for room: ", n), yield n.startAudio();
  });
  return { className: Y("start-audio-button"), roomAudioPlaybackAllowedObservable: Lo, handleStartAudioPlayback: e };
}
function qs() {
  const e = (n) => H(null, null, function* () {
    I.info("Start Video for room: ", n), yield n.startVideo();
  });
  return { className: Y("start-audio-button"), roomVideoPlaybackAllowedObservable: Io, handleStartVideoPlayback: e };
}
function Ks() {
  return { className: [Y("button"), Y("chat-toggle")].join(" ") };
}
function Gs() {
  return { className: [Y("button"), Y("focus-toggle-button")].join(" ") };
}
function Qs() {
  return { className: "lk-clear-pin-button lk-button" };
}
function Js() {
  return { className: "lk-room-container" };
}
function Kt(e, t, n = !0) {
  const i = [e.localParticipant, ...Array.from(e.remoteParticipants.values())], o = [];
  return i.forEach((s) => {
    t.forEach((a) => {
      const c = Array.from(
        s.trackPublications.values()
      ).filter(
        (u) => u.source === a && // either return all or only the ones that are subscribed
        (!n || u.track)
      ).map((u) => ({
        participant: s,
        publication: u,
        source: u.source
      }));
      o.push(...c);
    });
  }), { trackReferences: o, participants: i };
}
function Gt(e, t, n = !1) {
  const { sources: r, kind: i, name: o } = t;
  return Array.from(e.trackPublications.values()).filter(
    (a) => (!r || r.includes(a.source)) && (!i || a.kind === i) && (!o || a.trackName === o) && // either return all or only the ones that are subscribed
    (!n || a.track)
  ).map((a) => ({
    participant: e,
    publication: a,
    source: a.source
  }));
}
function Xs(e, t, n) {
  var r, i;
  const o = (r = n.additionalRoomEvents) != null ? r : _n, s = (i = n.onlySubscribed) != null ? i : !0, a = Array.from(
    (/* @__PURE__ */ new Set([
      y.ParticipantConnected,
      y.ParticipantDisconnected,
      y.ConnectionStateChanged,
      y.LocalTrackPublished,
      y.LocalTrackUnpublished,
      y.TrackPublished,
      y.TrackUnpublished,
      y.TrackSubscriptionStatusChanged,
      ...o
    ])).values()
  );
  return ve(e, ...a).pipe(
    _((u) => {
      const l = Kt(u, t, s);
      return I.debug(`TrackReference[] was updated. (length ${l.trackReferences.length})`, l), l;
    }),
    U(Kt(e, t, s))
  );
}
function Zs(e, t) {
  return Ce(e, ...po).pipe(
    _((r) => {
      const i = Gt(r, t);
      return I.debug(`TrackReference[] was updated. (length ${i.length})`, i), i;
    }),
    U(Gt(e, t))
  );
}
function $n(e, t) {
  return new L((r) => {
    const i = (...s) => {
      r.next(s);
    };
    return e.on(t, i), () => {
      e.off(t, i);
    };
  });
}
function ea(e) {
  return $n(e, Jt.TranscriptionReceived);
}
function ta(e) {
  return $n(e, Jt.TimeSyncUpdate).pipe(
    _(([t]) => t)
  );
}
function na(e, t = 1e3) {
  if (e === null) return dt(!1);
  const n = pt(e, "mousemove", { passive: !0 }).pipe(_(() => !0)), r = n.pipe(
    Mi({
      each: t,
      with: () => ze(dt(!1), r.pipe(Xi(n)))
    }),
    Ki()
  );
  return r;
}
function Ho(e, t) {
  if (typeof localStorage > "u") {
    I.error("Local storage is not available.");
    return;
  }
  try {
    if (t) {
      const n = Object.fromEntries(
        Object.entries(t).filter(([, r]) => r !== "")
      );
      localStorage.setItem(e, JSON.stringify(n));
    }
  } catch (n) {
    I.error(`Error setting item to local storage: ${n}`);
  }
}
function zo(e) {
  if (typeof localStorage > "u") {
    I.error("Local storage is not available.");
    return;
  }
  try {
    const t = localStorage.getItem(e);
    if (!t) {
      I.warn(`Item with key ${e} does not exist in local storage.`);
      return;
    }
    return JSON.parse(t);
  } catch (t) {
    I.error(`Error getting item from local storage: ${t}`);
    return;
  }
}
function Yo(e) {
  return {
    load: () => zo(e),
    save: (t) => Ho(e, t)
  };
}
var qo = `${An}-user-choices`, Ee = {
  videoEnabled: !0,
  audioEnabled: !0,
  videoDeviceId: "default",
  audioDeviceId: "default",
  username: ""
}, { load: Ko, save: Go } = Yo(qo);
function ra(e, t = !1) {
  t !== !0 && Go(e);
}
function ia(e, t = !1) {
  var n, r, i, o, s;
  const a = {
    videoEnabled: (n = e?.videoEnabled) != null ? n : Ee.videoEnabled,
    audioEnabled: (r = e?.audioEnabled) != null ? r : Ee.audioEnabled,
    videoDeviceId: (i = e?.videoDeviceId) != null ? i : Ee.videoDeviceId,
    audioDeviceId: (o = e?.audioDeviceId) != null ? o : Ee.audioDeviceId,
    username: (s = e?.username) != null ? s : Ee.username
  };
  if (t)
    return a;
  {
    const c = Ko();
    return X(X({}, a), c ?? {});
  }
}
var at = null, ct = null, Qo = 0;
function Qt() {
  return at || (at = /* @__PURE__ */ new Map()), at;
}
function Jo() {
  return ct || (ct = /* @__PURE__ */ new WeakMap()), ct;
}
function Xo(e, t) {
  const n = Jo();
  let r = n.get(e);
  return r || (r = `room_${Qo++}`, n.set(e, r)), `${r}:${t}`;
}
function oa(e, t) {
  const n = Xo(e, t), r = Qt(), i = r.get(n);
  if (i)
    return i;
  const o = new ie();
  let s = [];
  const a = "lk.segment_id", c = o.pipe(
    Zi({
      subscribe: () => {
        e.registerTextStreamHandler(t, (u, l) => H(null, null, function* () {
          var f;
          const v = be(u).pipe(
            $e((m, p) => m + p, "")
          ), d = !!((f = u.info.attributes) != null && f[a]);
          v.subscribe((m) => {
            const p = s.findIndex(
              (g) => {
                var h, x;
                return g.streamInfo.id === u.info.id || d && ((h = g.streamInfo.attributes) == null ? void 0 : h[a]) === ((x = u.info.attributes) == null ? void 0 : x[a]);
              }
            );
            p !== -1 ? (s[p] = le(X({}, s[p]), {
              text: m
            }), o.next([...s])) : (s.push({
              text: m,
              participantInfo: l,
              streamInfo: u.info
            }), o.next([...s]));
          });
        }));
      },
      finalize: () => {
        e.unregisterTextStreamHandler(t);
      }
    }),
    Ji()
  );
  return r.set(n, c), e.on(y.Disconnected, () => {
    Qt().delete(n), s = [], o.next([]);
  }), c;
}
function Un(e, t) {
  if (t.msg === "show_chat")
    return { ...e, showChat: !0, unreadMessages: 0 };
  if (t.msg === "hide_chat")
    return { ...e, showChat: !1 };
  if (t.msg === "toggle_chat") {
    const n = { ...e, showChat: !e.showChat };
    return n.showChat === !0 && (n.unreadMessages = 0), n;
  } else return t.msg === "unread_msg" ? { ...e, unreadMessages: t.count } : t.msg === "toggle_settings" ? { ...e, showSettings: !e.showSettings } : { ...e };
}
function Wn(e, t) {
  return t.msg === "set_pin" ? [t.trackReference] : t.msg === "clear_pin" ? [] : { ...e };
}
const Bn = D.createContext(void 0);
function sa() {
  const e = D.useContext(Bn);
  if (!e)
    throw Error("Tried to access LayoutContext context outside a LayoutContextProvider provider.");
  return e;
}
function aa(e) {
  const t = Zo();
  if (e ?? (e = t), !e)
    throw Error("Tried to access LayoutContext context outside a LayoutContextProvider provider.");
  return e;
}
function ca() {
  const [e, t] = D.useReducer(Wn, Ln), [n, r] = D.useReducer(Un, In);
  return {
    pin: { dispatch: t, state: e },
    widget: { dispatch: r, state: n }
  };
}
function ua(e) {
  const [t, n] = D.useReducer(Wn, Ln), [r, i] = D.useReducer(Un, In);
  return e ?? {
    pin: { dispatch: n, state: t },
    widget: { dispatch: i, state: r }
  };
}
function Zo() {
  return D.useContext(Bn);
}
const jn = D.createContext(
  void 0
);
function la() {
  const e = D.useContext(jn);
  if (!e)
    throw Error("tried to access track context outside of track context provider");
  return e;
}
function Vn() {
  return D.useContext(jn);
}
function fa(e) {
  const t = Vn(), n = e ?? t;
  if (!n)
    throw new Error(
      "No TrackRef, make sure you are inside a TrackRefContext or pass the TrackRef explicitly"
    );
  return n;
}
const Hn = D.createContext(void 0);
function da() {
  const e = D.useContext(Hn);
  if (!e)
    throw Error("tried to access participant context outside of participant context provider");
  return e;
}
function es() {
  return D.useContext(Hn);
}
function pa(e) {
  const t = es(), n = Vn(), r = e ?? t ?? n?.participant;
  if (!r)
    throw new Error(
      "No participant provided, make sure you are inside a participant context or pass the participant explicitly"
    );
  return r;
}
const zn = D.createContext(void 0);
function ha() {
  const e = D.useContext(zn);
  if (!e)
    throw Error("tried to access room context outside of livekit room component");
  return e;
}
function ts() {
  return D.useContext(zn);
}
function va(e) {
  const t = ts(), n = e ?? t;
  if (!n)
    throw new Error(
      "No room provided, make sure you are inside a Room context or pass the room explicitly"
    );
  return n;
}
const Yn = D.createContext(void 0);
function ma() {
  const e = D.useContext(Yn);
  if (!e)
    throw Error("tried to access session context outside of SessionProvider component");
  return e;
}
function ns() {
  return D.useContext(Yn);
}
function ga(e) {
  const t = ns(), n = e ?? t;
  if (!n)
    throw new Error(
      "No session provided, make sure you are inside a Session context or pass the session explicitly"
    );
  return n;
}
const rs = D.createContext(void 0);
function ba(e) {
  const t = D.useContext(rs);
  if (e === !0) {
    if (t)
      return t;
    throw Error("tried to access feature context, but none is present");
  }
  return t;
}
export {
  ra as $,
  Ts as A,
  es as B,
  Ro as C,
  Hs as D,
  Is as E,
  aa as F,
  ms as G,
  Ms as H,
  Ds as I,
  Ps as J,
  Os as K,
  rs as L,
  Ss as M,
  Ys as N,
  qs as O,
  Ks as P,
  js as Q,
  zn as R,
  Ns as S,
  $s as T,
  bo as U,
  Xs as V,
  ws as W,
  qt as X,
  Cs as Y,
  zs as Z,
  ia as _,
  sa as a,
  _s as a0,
  K as a1,
  Zs as a2,
  ta as a3,
  ea as a4,
  ys as a5,
  bs as a6,
  Fs as a7,
  go as a8,
  ks as a9,
  da as aA,
  ma as aB,
  la as aC,
  oa as aa,
  No as ab,
  ns as ac,
  ga as ad,
  Vn as ae,
  Bn as af,
  Vs as ag,
  os as ah,
  Yr as ai,
  Hn as aj,
  ba as ak,
  jn as al,
  na as am,
  cs as an,
  ua as ao,
  ps as ap,
  ds as aq,
  Yn as ar,
  ls as as,
  fs as at,
  gs as au,
  ca as av,
  ss as aw,
  us as ax,
  vs as ay,
  hs as az,
  Qs as b,
  pa as c,
  Bs as d,
  Es as e,
  ha as f,
  Uo as g,
  Ws as h,
  fa as i,
  Zo as j,
  Gs as k,
  I as l,
  as as m,
  vo as n,
  Fo as o,
  V as p,
  Ls as q,
  Lo as r,
  Js as s,
  Fn as t,
  va as u,
  Rs as v,
  ts as w,
  As as x,
  Us as y,
  xs as z
};
//# sourceMappingURL=contexts-DzwYztG5.mjs.map
